<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { cloneDeep, groupBy } from "lodash";
import { required } from "vuelidate/lib/validators";
import ApiType from "@/components/modals/api-type.vue";
import ApiResourceLogs from "@/components/modals/api-resource-logs.vue";
import ApiLogs from "@/components/modals/api-logs.vue";
import BackLogModal from "@/components/modals/backlogs.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import ImportPreplanning from "@/components/modals/import-preplanning.vue";
import ImportApi from "@/components/modals/import-api.vue";
import ProfileCropper from "@/components/modals/profile-cropper.vue";
import ResourceUpdate from "@/router/views/office/office-widgets/actual-resource-item.vue";
import RawData from "@/components/widgets/raw-data.vue";
import CartItems from "@/router/views/office/office-widgets/cart-items.vue";

const greaterThanZero = (value) => value.replace(/,/g, "") > 0;
export default {
    page: {
        title: "Actual OPCR/Deliverables",
    },
    components: {
        Layout,
        PageHeader,
        ApiType,
        ApiResourceLogs,
        ApiLogs,
        BackLogModal,
        UploadPopover,
        PrintOptions,
        ImportPreplanning,
        ImportApi,
        ProfileCropper,
        ResourceUpdate,
        RawData,
        CartItems
    },
    data() {
        return {
            title: this.$store.state.data.selectedCampus.isExternal ? "My Actual WFP" : "My Actual OPCR",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: this.$store.state.data.selectedCampus.isExternal ? "My Actual WFPs" : "My Actual OPCRs",
                    active: true,
                },
            ],
            targetData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 5,
            pageOptions: [5, 10, 25, 50, 100],
            filter: null,
            filterOn: ['name'],
            sortBy: "notification",
            sortDesc: true,
            fields: [
                {
                    key: "name",
                    label: "API Name",
                    sortable: true,
                },
                {
                    key: "totalCurrency",
                    sortable: true,
                    label: "Total Resources",
                    thStyle: { width: "180px" },
                },
                {
                    key: "score",
                    sortable: true,
                    thStyle: { width: "150px" },
                },

                {
                    key: "status",
                    sortable: true,
                    thStyle: { width: "200px" },
                },
                {
                    key: "actions",
                    thStyle: { width: "90px" },
                },
            ],
            form: {
                id: 0,
                name: "",
                description: "",
                isCatchUp: false,
                apiTypeId: "",
                scoreEfficiency: "",
                scoreQuality: "",
                scoreTimeliness: "",
                finalRemarks: "",
                catchUpPlans: "",
                isCompleted: false,
                dateCompleted: "",
            },
            indexSelected: -1,
            tableBusy: false,
            apiType: "",
            cycle: "",
            itemList: [],
            perPageItem: 1,
            currentPageItem: 1,
            filterItem: "",
            filterIndicatorItem: "",
            loadItems: false,
            selectedItem: 0,
            selectedApi: "",
            selectedApiId: 0,
            budgetItem: "",
            ppmpIndex: -1,
            apiName: "",
            selectedPPMPStatus: "",
            //budget
            filterBudget: "",
            budgetData: [],
            budgetBusy: false,
            selectedBudgetAmount: 0,
            item: {
                id: 0,
                itemName: "",
                description: "",
                unitId: "",
                type: "NON-CSE",
                itemCategoryId: "",
                unitCost: "0",
                cseId: 0,
                apiId: 0,
                deliveryUnitBudgetItemId: 0,
                isProcurable: true,
                isMixed: false,
            },

            // resource items
            itemLoading: false,
            resourceItems: [],
            itemIndex: -1,
            itemCategory: null,
            unit: "",

            // resource item details
            itemDetails: [],
            itemDetailFields: [
                {
                    key: "month.monthName",
                    label: "Month",
                    variant: "primary",
                },
                {
                    key: "quantity",
                    label: "Qty",
                    variant: "primary",
                    thStyle: { width: "120px" },
                },
                {
                    label: "Total",
                    key: "total",
                    variant: "primary",
                    thStyle: { width: "200px" },
                },
                {
                    key: "actions",
                    variant: "primary",
                    thStyle: { width: "90px" },
                    thClass: "text-center",
                    tdClass: "text-center",
                },
            ],
            detailError: false,
            detail: {
                id: 0,
                monthId: 0,
                quantity: "1",
                totalAmt: "0",
            },
            detailCopy: {
                id: 0,
                monthId: 0,
                quantity: "1",
                totalAmt: "0",
            },
            detailIndex: -1,
            apiIndex: -1,
            months: [],
            viewMenu: false,
            top: "0px",
            left: "0px",
            viewDetail: false,
            previousWork: {},
            uploadOptions: {
                type: "API",
                placement: "lefttop",
                folder: "Planning",
            },
            subType: "Goods",
            budgetCopy: 0,
            groupedBudget: [],
            selectedTransfer: {},
            budgetVirtual: 0,
            profileTobeUpdated: null,
            resourceIndex: null,
            optionStyle: "top:50%;left:50%;transform:translate(-50%,-50%);",
            itemOption: 0,
            isActive: false,
            visibilityOff: 0,
            packages: [],
            packageItems: [],
            selectedPackage: null,
            slideBLI: false,
            bliBtn: "",
            showBLIBtn: false,
            selectedBLI: null,
            viewAll: false,
            accountCategories: [],
            openModal: false,
            lastConsumed: null,
            transferBudget: false,
            goodError: false,
            inflationRate: null,
            packageItemIndex: 0,
            navigation: null,
            showBLIScreen: false,
            carouselStyle: '',
            hubConnector: null,
            importFromPrep: false,
            currentPageResource: 1,
            perPageResource: 5,
            isExternal: false,
            createMix: false,
            showOPCR: false,
            opcrs: [],
            searchOPCR: '',
            loadOpcrs: false,
            selectedOPCR: null,
            showTarget: false,
            selectedTarget: null,
            listMode: 'opcr',
            selectAllAPI: false,
            startTransferAPI: false,
            startTransferChecking: false,
            frontPage: true,
            filterChildParent: 0,
            budgetTransferModal: false,
            selectedApiCopy: null,
            itemToTransfer: null,
            motherID: null,
            selectedAllTarget: null,
            carts: [],
        };
    },
    validations: {
        form: {
            name: { required },
            description: { required },
            apiTypeId: { required },
        },
        previousWork: {
            name: { required },
        },
        item: {
            itemName: { required },
            description: { required },
            unitId: { required },
            type: { required },
            itemCategoryId: { required },
            unitCost: { required, greaterThanZero },
        },
        detail: {
            month: { required },
            quantity: { required, greaterThanZero },
        },
        subType: { required },
        motherID: { required },
    },
    watch:{
        $route (to, from){
            if(this.$route.params.id && this.$route.params.type === 'resource'){
                this.getApiByResource(this.$route.params.id);
            }
        }
    },
    computed: {
        rows() {
            if (this.filter) {
                return this.totalRows;
            }
            return this.targetData.length;
        },
        filteredOPCRs() {
            let data = this.opcrs;
            if (this.searchOPCR.trim() != "" && this.searchOPCR) {
                data = data.filter((item) => {
                    return item.title
                        .toUpperCase()
                        .includes(this.searchOPCR.toUpperCase());
                });
            }
            return data;
        },
        filteredApis() {
            let data = this.targetData;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var groupedClass = groupBy(data, "type");
            var classID = 1;
            var grouped = [];
            for (const key in groupedClass) {
                grouped.push({
                    id: classID++,
                    data: groupedClass[key],
                    key: key,
                });
            }
            return grouped;
        },
        filteredItems() {
            let data = this.itemList;
            let currentPage = this.currentPageItem;
            if (this.filterIndicatorItem.trim() != "" && this.filterIndicatorItem) {
                currentPage = 1;
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filterIndicatorItem.toUpperCase());
                });
            }
            var groupedPrexC = groupBy(data, "prexC");
            var PrexcID = 1;
            var iiID = 1;
            var grouped = [];
            for (const key in groupedPrexC) {
                var group = groupBy(groupedPrexC[key], "indicatorItem");
                var FC = [];
                for (const y in group) {
                    FC.push({
                        id: iiID++,
                        data: group[y],
                        key: y,
                    });
                }
                grouped.push({
                    id: PrexcID++,
                    data: FC,
                    key: key,
                });
            }
            var total = currentPage * this.perPageItem;
            var currentData = grouped.slice(total - this.perPageItem, total);
            return currentData;
        },
        filteredItemDetails() {
            let data = this.itemDetails;
            return data.sort((a, b) => a.monthId - b.monthId);
        },
        rowsItems() {
            let data = this.itemList;
            if (this.filterIndicatorItem.trim() != "" && this.filterIndicatorItem) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filterIndicatorItem.toUpperCase());
                });
            }
            var groupedPrexC = groupBy(data, "prexC");
            var PrexcID = 1;
            var iiID = 1;
            var grouped = [];
            for (const key in groupedPrexC) {
                var group = groupBy(groupedPrexC[key], "indicatorItem");
                var FC = [];
                for (const y in group) {
                    FC.push({
                        id: iiID++,
                        data: group[y],
                        key: y,
                    });
                }
                grouped.push({
                    id: PrexcID++,
                    data: FC,
                    key: key,
                });
            }
            return grouped.length;
        },
        filteredBudget() {
            let data = this.groupedBudget;
            if (this.filterBudget.trim() != "" && this.filterBudget) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filterBudget.toUpperCase());
                });
            }
            return data;
        },
        rowsBudget() {
            if (this.filterBudget.trim() != "" && this.filterBudget) {
                return this.filteredBudget.length;
            } else {
                return this.groupedBudget.length;
            }
        },
        filteredResourceItems() {
            let data = this.resourceItems;
            var total = this.currentPageResource * this.perPageResource;
            if(this.filterChildParent == 1){
                data = data.filter((item) => {
                    return item.mixParentId == 0;
                });
            }
            if(this.filterChildParent == 2){
                data = data.filter((item) => {
                    return item.mixParentId > 0;
                });
            }
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.itemName
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPageResource, total);
            if (this.currentPageResource > 1 && currentData.length == 0) {
                total = (this.currentPageResource - 1) * this.perPageResource;
                currentData = data.slice(total - this.perPageResource, total);
            }
            return currentData;
        },
        rowsResourceItem() {
            let data = this.resourceItems;
            if(this.filterChildParent == 1){
                data = data.filter((item) => {
                    return item.mixParentId == 0;
                });
            }
            if(this.filterChildParent == 2){
                data = data.filter((item) => {
                    return item.mixParentId > 0;
                });
            }
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.itemName
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            } 
            return data.length;
        },
        totalBudget() {
            var totalBalance = this.selectedBudgetAmount;
            let data =
                totalBalance -
                parseFloat(this.getExactAmt(this.detail.totalAmt));
            return data;
        },
        quantityTotal() {
            var data = this.itemDetails;
            return data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.quantity);
            }, 0);
        },
        amountTotal() {
            var data = this.itemDetails;
            var sum = data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.totalAmt);
            }, 0);
            return sum;
        },
        detailChecker() {
            return this.itemDetails.length;
        },
        isProcurableOption: {
            get(){
                if(this.item.isProcurable){
                    return 1;
                }
                return 2;
            },
            set(newValue){
                if(newValue == 1){
                    this.item.isProcurable = true;
                }else{
                    this.item.isProcurable = false;
                }
            }
        },
        isMixedOption: {
            get(){
                if(this.item.isMixed){
                    return 1;
                }
                return 2;
            },
            set(newValue){
                if(newValue == 1){
                    this.item.isMixed = true;
                }else{
                    this.item.isMixed = false;
                }
            }
        },
    },
    created() {
        this.totalRows = this.items.length;
        this.$store
            .dispatch("month/GetAllMonths")
            .then((res) => {
                this.months = res.data;
            })
            .catch(() => {
                this.showToast("Something went wrong!", "error");
            });
        this.$store
            .dispatch(
                "settings/GetInflationRate")
            .then((res) => {
                this.inflationRate = res.data;
            })
            .catch(() => {
                this.showToast("Something went wrong!", "error");
            });
        this.changeCycle(this.$store.state.data.cycle, true);
        this.getCartItems(this.$store.state.data.selectedDU.id);
    },
    beforeMount() {
        window.addEventListener("beforeunload", event => {
            if (!this.openModal) return
            event.preventDefault()
            event.returnValue = ""
        })
    },
    methods: {
        async getCartItems(id){
            await this.$store
                .dispatch("deliveryunititemcart/GetDeliveryUnitItemCartByDU", id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.filterKey = `${item.item.itemName} ${item.item.description}`;
                    })
                    this.carts = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        totalResourceItemAmt() {
            var data = this.resourceItems;
            var sum = 0;
            data.forEach((item) => {
                if(!item.mixParentId){
                    sum += parseFloat(item.totalWithInflation);
                }
            });
            return sum;
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        addApi(target) {
            if(target){
                this.selectedItem = target.planningTargetId;
                this.selectedAllTarget = target;
                this.selectedTarget = this.itemList.find(x => x.id == target.planningTargetId);
            }
            this.onReset();
            this.modalTitle = "Create New API";
            this.$bvModal.show("modal-standard");
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            if (this.form.isCatchUp) {
                this.$v.previousWork.$touch();
                if (this.$v.previousWork.$invalid) {
                    return;
                }
            } else {
                this.$v.previousWork.$reset();
            }
            var data = cloneDeep(this.form);
            data.dateCompleted = data.isCompleted
                ? this.getDate(this.form.dateCompleted)
                : this.getDate(new Date());
            data.targetId = this.selectedItem;
            if (this.form.id > 0) {
                this.$store
                    .dispatch("api/UpdateApi", data)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        if(this.selectAllAPI){
                            let index = this.selectedAllTarget.apis.findIndex(x => x.id == this.form.id);
                            data.filterKey = `${this.selectedAllTarget.target} ${data.name}`
                            this.selectedAllTarget.apis.splice(index, 1, data);
                        }else{
                            res.data.total = data.totalResources;
                            res.data.totalCurrency = this.formatCurrency(
                                data.totalResources
                            );
                            this.targetData.splice(this.indexSelected, 1, res.data);
                        }
                        this.$bvModal.hide("modal-standard");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                this.$store
                    .dispatch("api/CreateApi", data)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.showAttachments = false;
                        res.data.attachmentLoading = false;
                        res.data.addDocu = false;
                        res.data.fileSearch = "";
                        res.data.attachments = [];
                        if(this.selectAllAPI){
                            res.data.filterKey = `${this.selectedAllTarget.target} ${res.data.name}`
                            this.selectedAllTarget.apis.push(res.data);
                        }else{
                            res.data.totalCurrency = this.formatCurrency(0);
                            this.targetData.push(res.data);
                        }
                        this.$bvModal.hide("modal-standard");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            this.submitted = false;
        },
        onReset() {
            this.form = {
                id: 0,
                name: "",
                description: "",
                isCatchUp: false,
                apiTypeId: "",
                catchUpPlans: "",
                finalRemarks: "",
            };
            this.apiType = "";
            this.$v.form.$reset();
            this.$v.previousWork.$reset();
        },
        hideModal() {
            this.$bvModal.hide("modal-standard");
        },
        updateItem(props) {
            this.form = cloneDeep(props.item);
            this.form.dateCompleted = new Date(props.item.dateCompleted);
            this.apiType = props.item.apiType.type;
            this.indexSelected = this.targetData.indexOf(props.item);
            this.$v.form.$reset();
            this.$v.previousWork.$reset();
            this.modalTitle = "Update Api";
            this.$bvModal.show("modal-standard");
        },
        deleteItem(props) {
            var index = this.targetData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("api/DeleteApi", props.item.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.targetData.splice(index, 1);
                                this.$store.dispatch("filemanager/DeleteFileByReference", { referenceId: props.item.id, type: "API"})
                                this.showToast("Successfully deleted!", "success");
                            }
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        postPPMP(row) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, post it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("api/PostApi", row.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "warning");
                            }
                            row.status = "Posted";
                            this.showToast("Successfully posted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        postWork() {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, post it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("api/PostApi", this.selectedApiId)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "warning"
                                );
                            }
                            this.selectedPPMPStatus = "POSTED";
                            this.targetData[this.apiIndex].status = "Posted";
                            this.showToast("Successfully posted!", "success");
                            this.frontPage = true;
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        getApiType() {
            this.$bvModal.show("api-type-modal");
        },
        dropType(data) {
            this.apiType = data.type;
            this.form.apiTypeId = data.id;
        },
        async changeCycle(cycle, created = false) {
            if (!created) {
                this.frontPage = true;
            }
            this.resetSelection();
            this.pageLoader(true);
            await this.getMyOpcrs(cycle, this.$store.state.data.selectedDU.id);
            this.pageLoader(false);
            this.getMyTargets(cycle, this.$store.state.data.selectedDU.id);
        },
        resetSelection(){
            this.selectedOPCR = null;
            this.selectedTarget = null;
            this.selectedItem = 0;
            this.selectAllAPI = false;
            this.targetData = [];
        },
        async getMyOpcrs(cycle, deliveryUnitId){
            this.opcrs = [];
            this.loadOpcrs = true;
            await this.$store
                .dispatch("opcr/GetAllOpcr", {cycle, deliveryUnitId})
                .then((res) => {
                    if(res.data.error){
                        this.loadOpcrs = false;
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.opcrs = res.data;
                    if(this.opcrs.length > 0){
                        this.selectedOPCR = this.opcrs[0];
                    }
                })
                .catch(() => {
                    this.showToast("Getting Opcrs Failed", "error");
                });
            this.loadOpcrs = false
        },
        async getApiByResource(id){
            this.pageLoader(true);
            const {data} = await this.$store.dispatch('apiresource/GetSinglePPMPItem', id);
            const apiInfo = await this.$store.dispatch('api/GetSingleApi', data.apiId);
            let targetIndex = this.itemList.findIndex(item => item.id == apiInfo.data.targetId);
            if(targetIndex < 0){
                this.pageLoader(false);
                return this.showToast('Target not found', 'error');
            }
            await this.selectIndicatorItem(this.itemList[targetIndex]);
            await this.goToPPMP(apiInfo.data);
            let resourceIndex = this.resourceItems.findIndex(item => item.id == data.id);
            if(resourceIndex < 0){
                this.pageLoader(false);
                return this.showToast('API Resource not found', 'error');
            }
            let currentPage = Math.floor(resourceIndex/this.perPageResource);
            this.currentPageResource = currentPage + 1;
            this.$nextTick(() => {
                this.$refs[`resource-tr-${id}`][0].classList.add('resource-bg');
                setTimeout(() => {
                    var top = this.$refs[`resource-tr-${id}`][0].offsetTop;
                    window.scrollTo(0, top);
                }, 300)
            })
            this.pageLoader(false);
        },
        selectIndicatorItem(row, type = false) {
            this.selectedItem = row.id;
            this.apiName = row.description;
            this.selectedTarget = row;
            this.showTarget = false;
            this.selectAllAPI = false;
            this.getAPIbyOPCRandTarget();
        },
        getAPIbyOPCRandTarget(){
             if(!this.selectedTarget){
                return;
            }
            this.tableBusy = true;
            this.$store
                .dispatch("api/GetApiByTarget", {targetId: this.selectedTarget.id, opcrId: this.selectedOPCR.id})
                .then((res) => {
                    this.tableBusy = false;
                    if (res.data) {
                        res.data.forEach((item) => {
                            item.showAttachments = false;
                            item.attachmentLoading = false;
                            item.addDocu = false;
                            item.fileSearch = "";
                            item.attachments = [];
                            item.totalCurrency = this.formatCurrency(
                                item.totalResources
                            );
                        });
                        this.targetData = res.data;
                    } else {
                        this.targetData = [];
                    }
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        async goToPPMP(row) {
            this.selectedApi = row.name;
            this.selectedApiId = row.id;
            this.selectedPPMPStatus = row.status.toUpperCase();
            this.selectedApiCopy = cloneDeep(row);
            this.apiIndex = this.targetData.indexOf(row);
            this.title = "Office Budget Line Items";
            this.frontPage = false;
            this.scrollToTop();
            this.itemLoading = true;
            this.resourceItems = [];
            await this.$refs['resource-update'].getAllBudgets(row.id);
            await this.getResourceDetails(row.id);
        },
        async goToPPMPAll(row, parent){
            this.selectedAllTarget = parent;
            this.selectedApi = row.name;
            this.selectedApiId = row.id;
            this.selectedPPMPStatus = 'POSTED';
            this.selectedApiCopy = cloneDeep(row);
            this.title = "Office Budget Line Items";
            this.frontPage = false;
            this.scrollToTop();
            this.itemLoading = true;
            this.resourceItems = [];
            await this.$refs['resource-update'].getAllBudgets(row.id);
            await this.getResourceDetails(row.id);
        },
        returnToApi() {
            this.title = "My OPCR";
            this.frontPage = true;
        },
        async getResourceDetails(id) {
            await this.$store
                .dispatch("apiresource/GetAllResourceByAPI", id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let resourceItems = [];
                    res.data.map((item) => {
                        let budgetInfo = this.$refs['resource-update'].budgetData.find(
                            (x) => x.id == item.deliveryUnitBudgetItemId
                        );
                        item.deliveryUnitBudgetItem = {
                            fundSource: budgetInfo.fundSource,
                            fundClass: budgetInfo.fundClass,
                            accountGroup: budgetInfo.accountGroup,
                            accountId: budgetInfo.objectOfExpenditure.accountGroup.id,
                        };
                        item.thumbnailUrl = item.thumbnail
                            ? `${this.$store.state.data.rootFileDirectory}Procurement/${item.thumbnail}`
                            : "";
                        item.apiTransferId = 0;
                        if(item.mixParentId > 0){
                            let parent = res.data.find(x => x.id == item.mixParentId);
                            if(parent){
                                item.mixParentItemName = parent.itemName;
                            }
                        }
                        if(!item.mixParentId || item.mixParentId == 0){
                            item.kids = res.data.filter(kid => kid.mixParentId == item.id);
                            resourceItems.push(item);
                            for (const kid of item.kids) {
                                resourceItems.push(kid);
                            }
                        }
                    });
                    this.resourceItems = resourceItems;
                    this.itemLoading = false;
                })
                .catch((err) => {
                    this.itemLoading = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        deleteResourceItem(props) {
            console.log(this.selectedAllTarget);
            var index = this.resourceItems.indexOf(props);
            var budgetIndex = this.$refs['resource-update'].budgetData.findIndex((x) => x.id == props.deliveryUnitBudgetItemId);
            var apiIndex = -1;
            if(this.selectAllAPI){
                apiIndex = this.selectedAllTarget.apis.findIndex(x => x.id == props.apiId);
            }else{
                apiIndex = this.targetData.findIndex(x => x.id == props.apiId);
            }
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("apiresource/DeletePPMPItem", props.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            this.resourceItems.splice(index, 1);
                            if(props.mixParentId > 0){
                                this.resourceItems.find((e) => e.id == props.mixParentId).remaining += props.totalWithInflation;
                            }else{
                                if(this.selectAllAPI){
                                    this.selectedAllTarget.apis[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt());
                                }else{
                                    this.targetData[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt())
                                    this.targetData[apiIndex].totalCurrency = this.formatCurrency(this.targetData[apiIndex].totalResources);
                                }
                                this.$refs['resource-update'].budgetData[budgetIndex].balance += props.totalWithInflation;
                                this.$refs['resource-update'].budgetData[budgetIndex].totalWithInflation -= props.totalWithInflation;
                                this.$refs['resource-update'].budgetData[budgetIndex].resourceCount--;
                            }
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        viewItemLogs({ id }) {
            this.$refs.itemlog.getData(id);
            this.$bvModal.show("api-resoure-log-modal");
        },
        viewApiLogs(id){
            this.$refs.apilog.getData(id);
            this.$bvModal.show("api-log-modal");
        },
        resubmitItem(x) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to resubmit this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, resubmit it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("apiresource/ResubmitPPMPItem", x.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            x.technicalReviewStatus = "PENDING";
                            this.targetData[this.apiIndex].notification--;
                            this.showToast("Successfully resubmitted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        async updateResourceItem(props, type = "edit") {
            this.pageLoader(true);
            this.budgetTransferModal = false;
            this.$refs['resource-update'].getItemInfo(props, type);
            this.pageLoader(false);
        },
        async updateMixResourceItem(props) {
            this.pageLoader(true);
            this.budgetTransferModal = false;
            let parent = this.resourceItems.find(x => x.id == props.mixParentId);
            this.$refs['resource-update'].updateMixItem(props, parent);
            this.pageLoader(false);
        },
        getWork() {
            this.$refs.backlog.getData();
            this.$bvModal.show("backlog-modal");
        },
        dropWork(data) {
            this.previousWork = cloneDeep(data);
            this.form.apiId = data.id;
        },
        showDtls(row) {
            if (row.item.showAttachments) {
                row.item.showAttachments = !row.item.showAttachments;
                setTimeout(() => {
                    row.toggleDetails();
                }, 600);
            } else {
                this.getAttachments(row.item);
                row.toggleDetails();
                setTimeout(() => {
                    row.item.showAttachments = !row.item.showAttachments;
                }, 50);
            }
        },
        getAttachments(row) {
            row.attachmentLoading = true;
            row.attachments = [];
            this.$store
                .dispatch("filemanager/GetFiles", {
                    id: row.id,
                    type: this.uploadOptions.type,
                })
                .then((res) => {
                    row.attachmentLoading = false;
                    row.attachments = res.data;
                })
                .catch(() => {
                    row.attachmentLoading = false;
                    this.showToast(
                        "Something went wrong! - getting documents",
                        "error"
                    );
                });
        },
        removeFile(id, parentId) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("filemanager/DeleteFile", id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            let index = this.targetData.findIndex(
                                (item) => item.id == parentId
                            );
                            let yIndex = this.targetData[
                                index
                            ].attachments.findIndex((item) => item.id == id);
                            this.targetData[index].attachments.splice(
                                yIndex,
                                1
                            );
                            this.showToast("Successfully removed!", "success");
                        })
                        .catch(() => {
                            this.showToast("Cannot be removed!", "error");
                        });
                }
            });
        },
        uploadedDocument(response, id) {
            let index = this.targetData.findIndex((item) => item.id == id);
            this.targetData[index].attachments.push(response);
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        searchDocu(row) {
            let data = row.attachments;
            if (row.fileSearch.trim() != "" && row.fileSearch) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(row.fileSearch.toUpperCase());
                });
            }
            return data;
        },
        async printOPCR() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Planning/DU/OPCR",
                routeVariables: [this.selectedOPCR.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printWFP(){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/PrePlanning/WFP",
                routeVariables: [this.$store.state.data.cycle, this.$store.state.data.selectedDU.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printDULIB() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Planning/LIB/OPCR",
                routeVariables: [this.selectedOPCR.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        transferItem(row) {
            this.selectedTransfer = cloneDeep(row);
            this.frontPage = true;
        },
        cancelTransfer() {
            this.frontPage = true;
            this.selectedTransfer = {};
        },
        importNewItem() {
            this.importFromPrep = true;
            // this.openBLI();
        },
        dropImports(event) {
            let ids = [];
            let sum = 0;
            event.forEach((item) => {
                ids.push(item.id);
                sum = sum + parseFloat(item.total);
            });
            let data = {
                deliveryUnitBudgetItemId: this.selectedBLI.id,
                apiId: this.selectedApiId,
                apiResourceIds: ids,
            };
            this.$store
                .dispatch("apiresource/ImportResource", data)
                .then(async (res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.$bvModal.hide("preplanning-modal");
                    this.importFromPrep = false;
                    this.itemLoading = true;
                    this.resourceItems = [];
                    await this.getResourceDetails(this.selectedApiId);
                    this.budgetCopy -= sum;
                    this.budgetData[this.budgetIndex].balance -= sum;
                    this.budgetData[this.budgetIndex].totalWithInflation += sum;
                    this.closeAdding();
                    this.showToast("Successfully imported!", "success");
                })
                .catch(() => {
                    this.showToast(
                        "Something went wrong in importing!",
                        "error"
                    );
                });
        },
        importApi() {
            this.$refs.importapi.getData();
            this.$bvModal.show("import-api-modal");
        },
        dropImportedApi(event) {
            let data = {
                targetId: this.selectedItem,
                prePlanningApiIds: [],
            };
            event.forEach((item) => {
                data.prePlanningApiIds.push(item.id);
            });
            this.$store
                .dispatch("api/ImportPreplanningApi", data)
                .then(async (res) => {
                    this.$bvModal.hide("import-api-modal");
                    let index = this.itemList.findIndex(
                        (item) => item.id == this.selectedItem
                    );
                    this.selectIndicatorItem(this.itemList[index], true);
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong in importing!",
                        "error"
                    );
                });
        },
        filteredBudgetChild(info) {
            let data = cloneDeep(info);
            if (this.filterBudget.trim() != "" && this.filterBudget) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filterBudget.toUpperCase());
                });
            }
            return data;
        },
        updateProfile(row) {
            this.resourceIndex = this.resourceItems.indexOf(row);
            this.profileTobeUpdated = row;
            this.modalTitle = "Update Profile";
            this.$bvModal.show("upload-profile");
            this.$refs.profileCropper.resetData();
            if (row.image) {
                this.$refs.profileCropper.updateProfile = true;
                this.$refs.profileCropper.imageUrl = `${this.$store.state.data.rootFileDirectory}Procurement/${row.image}`;
                this.$refs.profileCropper.showCropBtn = true;
            }else{
                this.$refs.profileCropper.updateProfile = false;
                this.$refs.profileCropper.imageUrl = "";
            }
        },
        async cropData(event) {
            let updateProfile = await this.updateApiResourceImg(event, this.profileTobeUpdated);
            if(updateProfile.success){
                this.resourceItems[this.resourceIndex].image = updateProfile.data.image;
                this.resourceItems[this.resourceIndex].thumbnail = updateProfile.data.thumbnail;
                this.resourceItems[
                    this.resourceIndex
                ].thumbnailUrl = `${this.$store.state.data.rootFileDirectory}Procurement/${updateProfile.data.thumbnail}`;
                this.$bvModal.hide("upload-profile");
                this.showToast("Successfully uploaded!", "success");
            }else{
                this.showToast(updateProfile.data, "error");
            }
        },
        async closeModal(){
            if(this.viewDetail || this.createMix){
                return this.closeAdding();
            }
            let proceed = false;
            if((this.itemOption == 1 && this.selectedPackage) || (this.itemOption == 2 && this.itemDetails.length > 0)){
                await Swal.fire({
                    title: "Are you sure?",
                    text: "You will lose your progress!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#5c636a",
                    cancelButtonColor: "#7367f0",
                    confirmButtonText: "Yes, close it!",
                }).then((result) => {
                    if (result.value) {
                        proceed = true;
                    }
                });
            }else{
                proceed = true;
            }
            if(!proceed){
                return;
            }
            if(this.itemIndex > -1){
                let totalQuantity = 0;
                let totalAmount = 0;
                this.itemDetails.forEach(item => {
                    if(item.id > 0){
                        totalQuantity += item.quantity;
                        totalAmount += item.totalAmt;
                    }
                })
                this.resourceItems[this.itemIndex].totalQuantity = totalQuantity;
                this.resourceItems[this.itemIndex].totalWithInflation = totalAmount;
            }
            this.closeAdding();
        },
        closeAdding() {
            document.body.classList.remove('resource-open');
            this.slideBLI = false;
            this.showBLIBtn = false;
            this.viewAll = false;
            this.isActive = false;
            this.visibilityOff = 0;
            this.itemOption = 0;
            this.optionStyle =
                "top:50%;left:50%;transform:translate(-50%,-50%);";
            this.openModal = false;
            this.selectedBLI = null;
            this.budgetIndex = -1;
            this.budgetCopy = 0;
            this.selectedBudgetAmount = 0;
            this.budgetVirtual = 0;
        },
        getFundSourceTotal(row) {
            let total = 0;
            row.data.forEach((x) => {
                x.data.forEach((y) => {
                    y.data.forEach((z) => {
                        total += z.totalWithInflation;
                    });
                });
            });
            return total;
        },
        getFundSourceBalance(row) {
            let balance = 0;
            row.data.forEach((x) => {
                x.data.forEach((y) => {
                    y.data.forEach((z) => {
                        balance += z.balance;
                    });
                });
            });
            return balance;
        },
        notifyForUpdates(row){
            this.$store
                .dispatch("apiresource/TraceItem", {
                    id: row.id,
                    IsNotify: !row.notify,
                })
                .then((res) => {
                    this.showToast("Successfully set!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        onPageChange(event, type){
            this.detailError = false;
            this.goodError = false;
            let packageIndex = cloneDeep(event);
            if(type === 'forward'){
                this.updateNewInfo(this.packageItems[event])
                packageIndex = event+1;
                this.packageItemIndex++;
            }else if(type === 'backward'){
                this.updateNewInfo(this.packageItems[event])
                packageIndex = event-1;
                this.packageItemIndex--;
            }else{
                this.packageItemIndex = event;
            }
            this.carouselStyle = `transform:translateX(-${this.packageItems[packageIndex].left}px);`;
            this.itemDetails = [];
            this.assignPackageItem(this.packageItems[packageIndex]);
        },
        updateNewInfo(row){
            row.itemDetails = this.itemDetails ? cloneDeep(this.itemDetails) : [];
            row.item.unitCost = this.item.unitCost;
            row.item.unitId = this.item.unitId;
            row.item.itemCategoryId = this.item.itemCategoryId;
            row.item.unit.shortName = this.unit;
            row.item.description = this.item.description;
            row.item.type = this.item.type;
        },
        assignPackageItem(row){
            this.item = {
                id: 0,
                itemName: row.item.itemName,
                description: row.item.description,
                unitId: row.item.unitId,
                itemCategoryId: row.item.itemCategoryId,
                cseId: row.item.id,
                isProcurable: row.item.isProcurable,
                subType: row.item.subType,
            };
            if (row.item.inDbm) {
                this.item.type = "CSE";
            } else {
                this.item.type = "NON-CSE";
            }
            this.item.unitCost = this.numberWithCommas(row.item.unitCost);
            this.unit = row.item.unit.shortName;
            this.itemCategory = this.accountCategories.find(
                (x) => x.id == row.item.itemCategoryId
            );
            this.itemDetails = cloneDeep(row.itemDetails);
        },
        packageTotal(){
            if(this.selectedBLI){
                let balance = cloneDeep(this.selectedBLI.balance);
                let total = cloneDeep(this.budgetVirtual);
                return parseFloat(balance) - parseFloat(total);
            }else{
                return 0;
            }
        },
        resetPackage(){
            this.packageItems = [];
            this.selectedPackage = null;
            this.onResetResourceItem();
        },
        async onSubmitPackage(){
            this.updateNewInfo(this.packageItems[this.packageItemIndex]);
            this.detailError = false;
            this.goodError = false;
            this.submitted = true;
            if(this.budgetVirtual < 0){
                return this.showToast("Budget is not enough!", "error");
            }
            let errorArr = [];
            let emptyDetails = 0;
            this.packageItems.forEach((item, index) => {
                if(item.itemDetails.length == 0){
                    emptyDetails++;
                }
                if (item.item.isProcurable && this.selectedBLI.objectOfExpenditure.accountGroup.fundClassification.goodMax > 0 && this.getExactAmt(item.item.unitCost) >= this.selectedBLI.objectOfExpenditure.accountGroup.fundClassification.goodMax && item.item.subType && item.item.subType === 'Goods') {
                    errorArr.push(index);
                }
                if (item.item.isProcurable && this.selectedBLI.objectOfExpenditure.accountGroup.fundClassification.goodMin > 0 && this.getExactAmt(item.item.unitCost) < this.selectedBLI.objectOfExpenditure.accountGroup.fundClassification.goodMin && item.item.subType && item.item.subType === 'Goods') {
                    errorArr.push(index);
                }
            })
            if(emptyDetails == this.packageItems.length){
                this.onPageChange(this.packageItemIndex);
                if (this.detailChecker == 0) {
                    this.detailError = true;
                    return;
                }
            }
            if(errorArr.length > 0){
                this.onPageChange(errorArr[0]);
                this.$v.item.$touch();
                if (this.$v.item.$invalid) {
                    return;
                }
                if (this.item.isProcurable && this.selectedBLI.objectOfExpenditure.accountGroup.fundClassification.goodMax > 0 && this.getExactAmt(this.item.unitCost) >= this.selectedBLI.objectOfExpenditure.accountGroup.fundClassification.goodMax && this.subType && this.subType === 'Goods') {
                    this.goodError = true;
                    return;
                }
                if (this.item.isProcurable && this.selectedBLI.objectOfExpenditure.accountGroup.fundClassification.goodMin > 0 && this.getExactAmt(this.item.unitCost) < this.selectedBLI.objectOfExpenditure.accountGroup.fundClassification.goodMin  && this.subType && this.subType === 'Goods') {
                    this.goodError = true;
                    return;
                }
            }
            let proceed = true;
            if(emptyDetails > 0){
                await Swal.fire({
                    title: "Warning!",
                    text: `There are ${emptyDetails} item(s) with no details. Do you want to continue?`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#f1b44c",
                    cancelButtonColor: "#5c636a",
                    confirmButtonText: "Yes, proceed!",
                }).then((result) => {
                    if (result.value) {
                        proceed = true;
                    }else{
                        proceed = false;
                    }
                });
            }
            let data = [];
            if(proceed){
                // for await(const item of this.packageItems){
                //     if(item.itemDetails.length > 0){
                //         item.item.apiResourceDetails = item.itemDetails;
                //         data.push({...item.item, apiId: this.selectedApiId, deliveryUnitBudgetItemId: this.selectedBLI.id});
                //     }
                // }
                // this.submitPackageResources(data);
                for await(const item of this.packageItems){
                    if(item.itemDetails.length > 0){
                        this.assignPackageItem(item);
                        await this.onSubmitResourceItem();
                    }
                }
                this.closeAdding();
            }
        },
        submitPackageResources(data){
            this.$store
                .dispatch("apiresource/CreateMultiplePPMPItem", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(
                            res.data.errorMessage,
                            "error"
                        );
                    }
                    this.showToast("Successfully added!", "success");
                    this.itemLoading = true;
                    this.resourceItems = [];
                    this.getResourceDetails(this.selectedApiId);
                    // let budgetIndex = this.budgetData.findIndex((e) => e.id === this.selectedBLI.id);
                    // let apiIndex = this.targetData.findIndex((e) => e.id === this.selectedApiId);
                    // this.budgetData[budgetIndex].resourceCount++;
                    // this.budgetData[budgetIndex].totalWithInflation += totalWithInflation;
                    // this.budgetData[budgetIndex].balance -= totalWithInflation;
                    // this.resourceItems.find((e) => e.id === id).total = totalWithInflation;
                    // this.targetData[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt());
                    // this.targetData[apiIndex].totalCurrency = this.formatCurrency(this.targetData[apiIndex].totalResources);
                    // this.lastConsumed = null;
                })
                .catch((e) => {
                    this.showToast("Something went wrong!", "error");
                    this.submitted = false;
                });
        },
        transferIfs(row){
            if(this.selectedTransfer.id){
                if(this.selectedTransfer.deliveryUnitBudgetItem.accountId == row.objectOfExpenditure.accountGroup.id){
                    return true;
                }
                return false;
            }else{
                if(this.item.id > 0){
                    if(this.item.deliveryUnitBudgetItem.accountId == row.objectOfExpenditure.accountGroup.id){
                        if(row.id == (this.selectedBLI && this.selectedBLI.id)){
                            return false;
                        }
                        return true;
                    }
                    return false;
                }
                return false;
            }
        },
        transferApiIfs(row){
            if(this.selectedTransfer.apiId == row.id){
                return false;
            }
            if(row.status.toUpperCase() === "APPROVED" || row.status.toUpperCase() === "POSTED"){
                return false;
            }
            return true;
        },
        selectTransferApi(row){
            this.selectedTransfer.apiTransferId = row.id;
            let data = {
                deliveryUnitBudgetItemId: this.selectedTransfer.deliveryUnitBudgetItemId,
                apiResourceId: this.selectedTransfer.id,
                apiId: row.id,
            }
            this.$store
                .dispatch("apiresource/TransferResource", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    row.totalResources += this.selectedTransfer.total;
                    row.totalCurrency = this.formatCurrency(row.totalResources);
                    let index = this.targetData.findIndex((e) => e.id === this.selectedTransfer.apiId);
                    if(index > -1){
                        this.targetData[index].totalResources -= this.selectedTransfer.total;
                        this.targetData[index].totalCurrency = this.formatCurrency(this.targetData[index].totalResources);
                    }
                    this.cancelTransfer();
                    this.showToast("Successfully transferred!", "success");
                })
                .catch((err) => {
                    this.showToast("Cannot transfer!", "error");
                });
            // this.openBLI();
        },
        showPackageModal(){
            this.$refs.pckModal.getData();
            this.$bvModal.show("package-modal");
        },
        async changeDU(du){
            this.frontPage = true;
            this.title = du.isExternal ? "My Actual WFP" : "My Actual OPCR",
            this.items = [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: du.isExternal ? "My Actual WFPs" : "My Actual OPCRs",
                    active: true,
                },
            ],
            this.resetSelection();
            this.pageLoader(true);
            await this.getMyOpcrs(this.$store.state.data.cycle, du.id);
            this.pageLoader(false);
            this.getMyTargets(this.$store.state.data.cycle, du.id);
            this.selectAllAPI = false;
        },
        getMyTargets(cycle, deliveryUnitId){
            this.$store
                .dispatch("target/GetMyTarget", {cycle, deliveryUnitId})
                .then((res) => {
                    this.loadItems = false;
                    res.data.forEach((item) => {
                        item.actualQ1 = item.actual.length > 0 ? item.actual[0].q1 : "0";
                        item.actualQ2 = item.actual.length > 0 ? item.actual[0].q2 : "0";
                        item.actualQ3 = item.actual.length > 0 ? item.actual[0].q3 : "0";
                        item.actualQ4 = item.actual.length > 0 ? item.actual[0].q4 : "0";
                        item.filterKey = `${item.remarks} ${item.mainTarget.indicatorItem.indicatorItemName}`;
                        item.prexC = item.mainTarget.indicatorItem.indicator.prexc.prexcName;
                        item.indicatorItem = item.mainTarget.indicatorItem.indicatorItemName;
                    });
                    res.data.sort((a, b) => b.id - a.id);
                    this.itemList = res.data;
                })
                .catch((err) => {
                    this.loadItems = false;
                    this.showToast("Getting Target went wrong!", "error");
                });
        },
        async createMixItem(props){
            this.pageLoader(true);
            this.$refs['resource-update'].createMixItem(props);
            this.pageLoader(false);
        },
        getItemCategory() {
            this.$bvModal.show("item-category-modal");
        },
        dropItemCat(data) {
            this.itemCategory = data;
            this.item.itemCategoryId = data.id;
        },
        async getAllAPI(){
            this.selectAllAPI = true;
            this.targetData = [];
            this.tableBusy = true;
            this.selectedTarget = null;
            this.showTarget = false;
            this.apiName = 'All';
            this.selectedItem = 0;
            if(!this.selectedOPCR) {
                return this.tableBusy = false;
            }
            await this.$store
                // .dispatch("api/GetApiByOpcr", this.selectedOPCR.id)
                .dispatch("api/GetAllApisByDepartment", {opcrId: this.selectedOPCR.id, departmentId: this.$store.state.data.selectedDepartment.id})
                .then((res) => {
                    this.tableBusy = false;
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((x) => {
                        x.sort = 3;
                        if(x.type.toLowerCase().includes('strategic')){
                            x.sort = 1;
                        }else if(x.type.toLowerCase().includes('core')){
                            x.sort = 2
                        }
                        x.showApis = x.apis.length;
                        x.filterKey = `${x.target}`;
                        x.apis.map(item => {
                            item.showAttachments = false;
                            item.attachmentLoading = false;
                            item.addDocu = false;
                            item.fileSearch = "";
                            item.attachments = [];
                            item.totalResources = this.formatCurrency(item.total);
                            item.selected = false;
                            x.filterKey += ` ${item.name}`;
                            item.filterKey = `${x.target} ${item.name}`;
                        })
                    });
                    this.targetData = res.data.sort((a, b) => a.sort - b.sort);
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        closeTargetPopOver(){
            this.showTarget = false;
            this.startTransferAPI = false;
        },
        printPPMP(){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/My/PPMP/OPCR",
                routeVariables: [this.selectedOPCR.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        printTPMS(){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Planning/TPMS",
                routeVariables: [this.selectedOPCR.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        printPPMPByApi(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/My/PPMP/API",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        selectOPCR(opcr){
            // if(this.startTranferApiToOPCR){
            //     if(this.selectedOPCR.id == opcr.id){
            //         this.showToast('Cannot transfer to the same OPCR', 'error');
            //         return;
            //     }
            //     this.transferToSelectedOPCR(opcr.id);
            // }else{
                this.selectedOPCR = cloneDeep(opcr);
                this.showOPCR = false;
                if(this.selectAllAPI){
                    this.getAllAPI();
                }else{
                    this.getAPIbyOPCRandTarget();
                }
            // }
        },
        closeUpdateModal(data){
            let index = this.resourceItems.findIndex(x => x.id == data.id);
            this.resourceItems[index].totalQuantity = data.quantity;
            this.resourceItems[index].totalWithInflation = data.amount;
        },
        successUpdateResource(data){
            let index = this.resourceItems.findIndex(x => x.id == data.id);
            this.resourceItems.splice(index, 1, data);
        },
        successAddResource(data){
            if(data.mixParentId && data.mixParentId > 0){
                let filterChilds = this.resourceItems.filter(x => x.mixParentId == data.mixParentId);
                if(filterChilds.length > 0){
                    let index = this.resourceItems.findIndex(x => x.id == filterChilds[filterChilds.length - 1].id);
                    this.resourceItems.splice(index + 1, 0, data);
                }else{
                    let index = this.resourceItems.findIndex(x => x.id == data.mixParentId);
                    this.resourceItems.splice(index + 1, 0, data);
                }
            }else{
                this.resourceItems.push(data);
            }
        },
        updateItemColumn(data){
            if(data.type === 'deduct'){
                let rowItem = this.resourceItems.find((e) => e.id == data.id)
                rowItem[data.column] -= data.value;
                if(rowItem.mixParentId > 0){ this.recalculateMixTotals(rowItem.mixParentId) }
            }else if(data.type === 'add'){
                this.resourceItems.find((e) => e.id == data.id)[data.column] += data.value;
            }else{
                this.resourceItems.find((e) => e.id == data.id)[data.column] = data.value;
            }
        },
        recalculateMixTotals(id){
            let sum = 0;
            this.resourceItems.forEach((item) => {
                if(item.mixParentId == id){
                    sum += parseFloat(item.totalWithInflation);
                }
            });
            let mixItem = this.resourceItems.find((e) => e.id == id);
            mixItem.remaining = mixItem.totalWithInflation - sum;
        },
        updateTotals(data){
            if(this.selectAllAPI){
                let apiIndex = this.selectedAllTarget.apis.findIndex((e) => e.id == data.apiId)
                this.selectedAllTarget.apis[apiIndex].totalResources = this.formatCurrency(cloneDeep(this.totalResourceItemAmt()));
                this.selectedAllTarget.apis[apiIndex].totalCurrency = this.formatCurrency(this.totalResourceItemAmt());
            }else{
                let apiIndex = this.targetData.findIndex((e) => e.id === data.apiId);
                this.targetData[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt());
                this.targetData[apiIndex].totalCurrency = this.formatCurrency(this.totalResourceItemAmt());
            }
        },
        updatePackage(id){
            this.itemLoading = true;
            this.resourceItems = [];
            this.getResourceDetails(id);
        },
        addNewItem() {
            this.budgetTransferModal = true;
            this.$refs['resource-update'].addNewItem();
        },
        transferToMother(x){
            this.itemToTransfer = cloneDeep(x);
            this.$bvModal.show('transfer-mother-modal');
        },
        async onTransferToMother(){
            let data = cloneDeep(this.itemToTransfer);
            data.mixParentId = this.motherID;
            this.submitted = true;
            this.$v.motherID.$touch();
            if (this.$v.motherID.$invalid) {
                return;
            }
            await this.$store
                .dispatch("apiresource/UpdatePPMPItem", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.resourceItems.findIndex((e) => e.id == data.id);
                    let motherIndex = this.resourceItems.findIndex((e) => e.id == this.motherID);
                    if(this.itemToTransfer.mixParentId && this.itemToTransfer.mixParentId > 0){
                        this.resourceItems.find((e) => e.id == this.itemToTransfer.mixParentId).remaining += data.totalWithInflation;                    
                    }
                    if(motherIndex > -1){
                        this.resourceItems.splice(index, 1);
                        this.resourceItems.splice(motherIndex, 0, data);
                        this.resourceItems[motherIndex].remaining -= data.totalWithInflation;
                    }
                    this.$bvModal.hide('transfer-mother-modal');
                    this.showToast("Successfully transferred!", "success");
                })
                .catch((e) => {
                    this.showToast("Something went wrong!", "error");
                    this.submitted = false;
                });
        },
        filterApiCards(apis){
            let data = apis;
            if(this.filter && this.filter.trim !== ''){
                data = data.filter(x => {
                    return x.filterKey.toUpperCase().includes(this.filter.toUpperCase());
                })
            }
            return data;
        },
        showCart(){
            this.$bvModal.show('cart-items-modal');
        },
        selectCartItem(item){
            let dataItem = cloneDeep(item.item);
            dataItem.cartItemId = item.id;
            this.$refs['resource-update'].dropItem(dataItem, true);
            this.$bvModal.hide('cart-items-modal');
        },
        removeFromCart(id){
            this.$store
                .dispatch("deliveryunititemcart/DeleteDeliveryUnitItemCart", id)
                .then((res) => {
                    if(res.data.error){
                        return;
                    }
                    let index = this.carts.findIndex(x => x.id == id);
                    this.carts.splice(index, 1);
                })
                .catch((err) => {
                    return;
                });
        },
    }
};
</script>

<template>
    <Layout @changeCycle="changeCycle" @changeDU="changeDU">
        <PageHeader :title="title" :items="items" />
        <profile-cropper
            ref="profileCropper"
            @crop-picture="cropData"
        ></profile-cropper>
        <ResourceUpdate 
            ref="resource-update" 
            :budgetTransferModal="budgetTransferModal"
            :updatableMixOption="false"
            :selectedApiId="selectedApiId"
            :selectedTransfer="selectedTransfer"
            :carts="carts"
            @close-update="closeUpdateModal" 
            @update-item="successUpdateResource" 
            @add-item="successAddResource" 
            @specific-item-update="updateItemColumn"
            @update-package="updatePackage"
            @update-totals="updateTotals"
            @recalculate-totals="recalculateMixTotals"
            @refresh-all="goToPPMP(selectedApiCopy)"
            @view-cart="showCart"
            @remove-from-cart="removeFromCart"
        />
        <b-modal
            id="transfer-mother-modal"
            title="Transfer to Mother"
            size="sm"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onTransferToMother"
                class="needs-validation"
                ref="fcForm"
            >
                <div class="mb-3">
                    <label for="motherID"> Mother ID </label>
                    <input
                        autocomplete="off"
                        id="motherID"
                        type="text"
                        v-model="motherID"
                        placeholder="Enter Mother ID..."
                        class="form-control"
                        :class="{'is-invalid': submitted && $v.motherID.$error}"
                    />
                    <div v-if="submitted && $v.motherID.$error" class="invalid-feedback">
                        <span v-if="!$v.motherID.required">This value is required.</span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        type="submit"
                        class="btn btn-primary"
                    >
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('transfer-mother-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <div class="row position-relative">
            <div class="col-12">
                <div v-if="frontPage">
                    <b-row >
                        <b-col sm="3">
                            <div
                                class="
                                    d-flex
                                    align-items-center
                                    justify-content-between
                                    mb-3
                                "
                            >
                                <div></div>
                                <b-dropdown
                                    id="dropdown-dropleft"
                                    right
                                    variant="purple btn-sm"
                                    toggle-class="text-decoration-none"
                                    menu-class="dropdown-menu"
                                    no-caret
                                >
                                    <template #button-content>
                                        <i class="bx bx-printer me-1"></i> Reports
                                    </template>
                                    <b-dropdown-item @click="printOPCR()" v-if="!$store.state.data.selectedCampus.isExternal"
                                        >OPCR</b-dropdown-item
                                    >
                                    <b-dropdown-item @click="printWFP()" v-if="$store.state.data.selectedCampus.isExternal"
                                        >WFP</b-dropdown-item
                                    >
                                    <b-dropdown-item @click="printDULIB()"
                                        >LIB</b-dropdown-item
                                    >
                                    <b-dropdown-item @click="printPPMP()"
                                        >PPMP</b-dropdown-item
                                    >
                                </b-dropdown>
                            </div>
                            <div>
                                <div class="mb-4">
                                    <div class="border-dashed-img position-relative p-5 text-center cursor-pointer"  :class="{'info selected': selectedOPCR}">
                                        <h5 class="text-muted py-4 hover-underline" v-if="!selectedOPCR" id="selectOPCR" @click="showOPCR = true"> Click to Select {{$store.state.data.selectedCampus.isExternal ? 'WFP' : 'OPCR'}} </h5>
                                        <div v-else id="selectOPCR" @click="showOPCR = true">
                                            <h5 class="mb-0 hover-underline">{{selectedOPCR.title}}</h5>
                                            <small v-if="selectedOPCR.isSupplemental" class="text-success font-weight-bold">Supplemental</small>
                                        </div>
                                        <span v-if="selectedOPCR" class="position-absolute bg-body px-2 text-info border" style="left:10px;top:-8px;">Selected {{$store.state.data.selectedCampus.isExternal ? 'WFP' : 'OPCR'}}</span>
                                    </div>
                                    <b-popover
                                        :show.sync="
                                            showOPCR
                                        "
                                        :target="`selectOPCR`"
                                        :custom-class="`popoverOPCRClass`"
                                        triggers="click"
                                        placement="right"
                                    >
                                        <template
                                            v-slot:title
                                        >
                                            <div class="d-flex justify-content-between align-items-center">
                                                <p class="m-0">Select {{$store.state.data.selectedCampus.isExternal ? 'WFP' : 'OPCR'}}</p>
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-danger"
                                                    @click="showOPCR = false"
                                                >
                                                    <i class="bx bx-x"></i>
                                                </button>
                                            </div>
                                        </template>
                                        <div class="d-flex align-items-center justify-content-between mb-3">
                                            <div>
                                                <input type="text" class="form-control form-control-sm" v-model="searchOPCR" :placeholder="`Search ${$store.state.data.selectedCampus.isExternal ? 'WFP' : 'OPCR'}`" v-if="opcrs.length > 0">
                                            </div>
                                        </div>
                                        <div v-if="loadOpcrs">
                                            <div class="text-center">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-if="!loadOpcrs && opcrs.length == 0">
                                            <div class="text-center">
                                                No data found...
                                            </div>
                                        </template>
                                        <template v-if="!loadOpcrs && opcrs.length > 0 && filteredOPCRs.length == 0">
                                            <div class="text-center">
                                                Search not found...
                                            </div>
                                        </template>
                                        <div class="scrollable-div pe-1">
                                            <div v-for="opcr in filteredOPCRs" :key="opcr.id">
                                                <div class="d-flex align-items-center justify-content-between border border-2 p-2 mb-2">
                                                    <h5 class="mb-0 cursor-pointer" @click="selectOPCR(opcr)">{{ opcr.title }}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </b-popover>
                                </div>
                                <div class="mb-3" v-if="selectedOPCR">
                                    <div class="border-dashed-img position-relative p-5 text-center cursor-pointer" id="selectTarget" @click="showTarget = true" :class="{'selected info': selectedItem > 0  && !selectAllAPI}">
                                        <h5 class="text-muted my-4" v-if="selectedItem == 0 || selectAllAPI"> Click to Select Target </h5>
                                        <div v-if="selectedItem != 0 && !selectAllAPI">
                                            <div class="mb-2">
                                                <span class="font-size-15 text-yellow">{{ selectedTarget.prexC }}</span>
                                                <div class="my-2 ms-3">
                                                    <span class="font-size-13 text-white">{{ selectedTarget.indicatorItem }}</span>
                                                    <div  class="mt-2">
                                                        <b-card
                                                            class="
                                                                p-0
                                                                shadow
                                                                cursor-pointer
                                                                border border-secondary
                                                            "
                                                            no-body
                                                        >
                                                            <b-card-header class="bg-secondary">
                                                                <b-card-title class="mb-0 text-white">{{selectedTarget.remarks}}</b-card-title>
                                                            </b-card-header>
                                                            <b-card-body class="p-0">
                                                                <div class="m-2 d-flex align-items-center justify-content-between">
                                                                    <b class="text-pink">
                                                                        {{selectedTarget.mainTarget.indicatorItem.indicatorItemClassification.classification}}
                                                                    </b>
                                                                    <a href="javascript:void(0);" :id="`quarter-selected-target-${selectedTarget.id}`">Quarterly Targets</a>
                                                                    <b-popover
                                                                        :target="`quarter-selected-target-${selectedTarget.id}`"
                                                                        triggers="hover"
                                                                        placement="right"
                                                                        custom-class="quarter-target-popover"
                                                                    >
                                                                        <template v-slot:title
                                                                            ><small>Quarterly Targets</small></template
                                                                        >
                                                                        <table class="table table-bordered">
                                                                            <tr>
                                                                                <td class="p-2 text-center">
                                                                                    Cascaded Target
                                                                                </td>
                                                                                <td class="p-2 text-center">
                                                                                    {{selectedTarget.mainTarget.indicatorItem.isPercentage ? `${selectedTarget.cascadedTarget}%` : selectedTarget.cascadedTarget}}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="p-2 text-center">
                                                                                    Quarter 1
                                                                                </td>
                                                                                <td class="p-2 text-center">
                                                                                    {{selectedTarget.mainTarget.indicatorItem.isPercentage ? `${selectedTarget.q1}%` : selectedTarget.q1}}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="p-2 text-center">
                                                                                    Quarter 2
                                                                                </td>
                                                                                <td class="p-2 text-center">
                                                                                    {{selectedTarget.mainTarget.indicatorItem.isPercentage ? `${selectedTarget.q2}%` : selectedTarget.q2}}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="p-2 text-center">
                                                                                    Quarter 3
                                                                                </td>
                                                                                <td class="p-2 text-center">
                                                                                    {{selectedTarget.mainTarget.indicatorItem.isPercentage ? `${selectedTarget.q3}%` : selectedTarget.q3}}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="p-2 text-center">
                                                                                    Quarter 4
                                                                                </td>
                                                                                <td class="p-2 text-center">
                                                                                    {{selectedTarget.mainTarget.indicatorItem.isPercentage ? `${selectedTarget.q4}%` : selectedTarget.q4}}
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </b-popover>
                                                                </div>
                                                            </b-card-body>
                                                        </b-card>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <span v-if="selectedItem > 0 && !selectAllAPI" class="position-absolute bg-body px-2 text-info border" style="left:10px;top:-8px;">Selected KPI</span>
                                    </div>
                                    <b-popover
                                        :show.sync="showTarget"
                                        :target="`selectTarget`"
                                        :custom-class="`popoverOPCRClass`"
                                        triggers="click"
                                        placement="right"
                                        id="targetRef"
                                        ref="targetRef"
                                    >
                                        <template
                                            v-slot:title
                                        >
                                            <div class="d-flex justify-content-between align-items-center">
                                                <p class="m-0">Select Target</p>
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-danger"
                                                    @click="closeTargetPopOver"
                                                >
                                                    <i class="bx bx-x"></i>
                                                </button>
                                            </div>
                                        </template>
                                        <b-row>
                                            <b-col sm="12">
                                                <label
                                                    >Select KPI
                                                    <span
                                                        v-if="
                                                            filteredItems.length == 0 &&
                                                            !loadItems
                                                        "
                                                        >- No Data Found</span
                                                    >
                                                    <span
                                                        class="text-danger"
                                                        v-if="
                                                            selectedItem == 0 &&
                                                            filteredItems.length > 0
                                                        "
                                                        >[Click on items]</span
                                                    >
                                                </label>
                                                
                                                <div class="mb-2">
                                                    <input
                                                        autocomplete="off"
                                                        id="name"
                                                        type="text"
                                                        v-model="filterIndicatorItem"
                                                        placeholder="Search KPI/Target..."
                                                        class="form-control"
                                                        @input="currentPageItem = 1"
                                                    />
                                                </div>
                                                <div
                                                    class="preloader-component ms-2"
                                                    v-if="loadItems"
                                                >
                                                    <div class="status">
                                                        <div
                                                            class="
                                                                spinner-chase
                                                                w-20px
                                                                h-20px
                                                            "
                                                        >
                                                            <div
                                                                class="chase-dot"
                                                            ></div>
                                                            <div
                                                                class="chase-dot"
                                                            ></div>
                                                            <div
                                                                class="chase-dot"
                                                            ></div>
                                                            <div
                                                                class="chase-dot"
                                                            ></div>
                                                            <div
                                                                class="chase-dot"
                                                            ></div>
                                                            <div
                                                                class="chase-dot"
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-col>
                                            <b-col
                                                sm="12"
                                                v-for="x in filteredItems"
                                                :key="x.id"
                                            >
                                                <div class="mb-2 scrollable-div">
                                                    <span class="font-size-15 text-yellow">{{ x.key }}</span>
                                                    <div class="my-2 ms-3" v-for="y in x.data" :key="`Y-${y.id}`">
                                                        <span class="font-size-13 text-white">{{ y.key }}</span>
                                                        <div  v-for="z in y.data" :key="`Z-${z.id}`" class="mt-2">
                                                        <b-card
                                                            class="
                                                                p-0
                                                                shadow
                                                                cursor-pointer
                                                                me-1
                                                            "
                                                            no-body
                                                            @click="selectIndicatorItem(z)"
                                                            :class="{
                                                                'border-radial-success':
                                                                    selectedItem == z.id,
                                                                'border border-secondary':
                                                                    selectedItem != z.id,
                                                            }"
                                                            @drop="onDropZone($event, z)"
                                                            @dragenter.prevent
                                                            @dragover.prevent
                                                        >
                                                            <b-card-header
                                                                :class="{
                                                                    'bg-secondary':
                                                                        selectedItem != z.id,
                                                                    'bg-success bg-soft':
                                                                        selectedItem == z.id,
                                                                }"
                                                            >
                                                                <b-card-title
                                                                    :class="{
                                                                        'text-white':
                                                                            selectedItem !=
                                                                            z.id,
                                                                        'text-primary':
                                                                            selectedItem ==
                                                                            z.id,
                                                                    }"
                                                                    class="mb-0"
                                                                    v-if="
                                                                        selectedItem != z.id &&
                                                                        z.remarks && z.remarks
                                                                            .length > 70
                                                                    "
                                                                    >
                                                                    {{
                                                                        z.remarks && z.remarks.substring(
                                                                            0,
                                                                            70
                                                                        )
                                                                    }}<a
                                                                        class="text-dark"
                                                                        href="javascript:void(0);"
                                                                        >...</a
                                                                    ></b-card-title
                                                                >
                                                                <b-card-title
                                                                    :class="{
                                                                        'text-white':
                                                                            selectedItem !=
                                                                            z.id,
                                                                        'text-dark':
                                                                            selectedItem ==
                                                                            z.id,
                                                                    }"
                                                                    class="mb-0"
                                                                    v-else
                                                                    >
                                                                    {{
                                                                        z.remarks
                                                                    }}</b-card-title
                                                                >
                                                            </b-card-header>
                                                            <b-card-body class="p-0">
                                                                <div class="m-2 d-flex align-items-center justify-content-between">
                                                                    <b class="text-pink">
                                                                        {{z.mainTarget.indicatorItem.indicatorItemClassification.classification}}
                                                                    </b>
                                                                    <a href="javascript:void(0);" :id="`quarter-target-${z.id}`">Quarterly Targets</a>
                                                                    <b-popover
                                                                        :target="`quarter-target-${z.id}`"
                                                                        triggers="hover"
                                                                        placement="right"
                                                                        custom-class="quarter-target-popover"
                                                                    >
                                                                        <template v-slot:title
                                                                            ><small>Quarterly Targets</small></template
                                                                        >
                                                                        <table class="table table-bordered">
                                                                            <tr>
                                                                                <td class="p-2 text-center">
                                                                                    Cascaded Target
                                                                                </td>
                                                                                <td class="p-2 text-center">
                                                                                    {{z.mainTarget.indicatorItem.isPercentage ? `${z.cascadedTarget}%` : z.cascadedTarget}}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="p-2 text-center">
                                                                                    Quarter 1
                                                                                </td>
                                                                                <td class="p-2 text-center">
                                                                                    {{z.mainTarget.indicatorItem.isPercentage ? `${z.q1}%` : z.q1}}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="p-2 text-center">
                                                                                    Quarter 2
                                                                                </td>
                                                                                <td class="p-2 text-center">
                                                                                    {{z.mainTarget.indicatorItem.isPercentage ? `${z.q2}%` : z.q2}}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="p-2 text-center">
                                                                                    Quarter 3
                                                                                </td>
                                                                                <td class="p-2 text-center">
                                                                                    {{z.mainTarget.indicatorItem.isPercentage ? `${z.q3}%` : z.q3}}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="p-2 text-center">
                                                                                    Quarter 4
                                                                                </td>
                                                                                <td class="p-2 text-center">
                                                                                    {{z.mainTarget.indicatorItem.isPercentage ? `${z.q4}%` : z.q4}}
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </b-popover>
                                                                </div>
                                                            </b-card-body>
                                                        </b-card>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-col>
                                            <b-col
                                                sm="12"
                                                v-if="
                                                    filteredItems.length > 0 &&
                                                    !loadItems
                                                "
                                            >
                                                <div
                                                    class="
                                                        dataTables_paginate
                                                        paging_simple_numbers
                                                        float-end
                                                    "
                                                >
                                                    <ul
                                                        class="
                                                            pagination
                                                            pagination-rounded
                                                            mb-0
                                                        "
                                                    >
                                                        <b-pagination
                                                            v-model="currentPageItem"
                                                            :total-rows="rowsItems"
                                                            :per-page="perPageItem"
                                                        ></b-pagination>
                                                    </ul>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-popover>
                                </div>
                                <div class="border-dashed-img position-relative p-3 text-center cursor-pointer" id="selectOPCR" @click="getAllAPI" :class="{'bg-info bg-soft info': selectAllAPI}" v-if="selectedOPCR">
                                    <h5 class="text-muted mb-0"> View All API's </h5>
                                </div>
                            </div>
                        </b-col>
                        <b-col sm="9">
                            <div class="card border shadow">
                                <div class="card-body">
                                    <div
                                        class="
                                            d-flex
                                            justify-content-between
                                            align-items-center
                                        "
                                    >
                                        <h4 class="card-title m-0">
                                            {{ apiName }} API List
                                        </h4>
                                        <!-- <div
                                            v-if="
                                                selectedItem > 0 &&
                                                !selectedTransfer.id
                                            "
                                            class="d-flex"
                                        >
                                            <button
                                                type="button"
                                                @click="importApi()"
                                                class="
                                                    btn btn-md btn-gradient-purple
                                                    d-flex
                                                    align-items-center
                                                    no-wrap
                                                    me-1
                                                "
                                            >
                                                <i
                                                    class="
                                                        bx bx-download
                                                        fs-6
                                                        me-1
                                                    "
                                                ></i
                                                >Import API
                                            </button> -->
                                            <button
                                                type="button"
                                                @click="addApi()"
                                                v-if="$store.state.decrypt.isAdmin() && !selectedTransfer.id && !selectAllAPI"
                                                class="
                                                    btn btn-md btn-info
                                                    d-flex
                                                    align-items-center
                                                    no-wrap
                                                "
                                            >
                                                <i
                                                    class="bx bx-plus fs-6"
                                                ></i
                                                >Create New
                                            </button>
                                        <!-- </div> -->
                                        <b-modal
                                            id="modal-standard"
                                            :title="modalTitle"
                                            size="md"
                                            title-class="font-18"
                                            hide-footer
                                            no-close-on-backdrop
                                            no-close-on-esc
                                        >
                                            <form
                                                @submit.prevent="onCreate"
                                                class="needs-validation"
                                                ref="apiForm"
                                            >
                                                <b-row>
                                                    <div class="col-md-12">
                                                        <div
                                                            :class="{
                                                                'border border-primary position-relative mb-3':
                                                                    form.isCatchUp,
                                                            }"
                                                        >
                                                            <div
                                                                :class="{
                                                                    isCatchup:
                                                                        form.isCatchUp,
                                                                }"
                                                                class="mb-3"
                                                            >
                                                                <input
                                                                    autocomplete="off"
                                                                    class="
                                                                        form-check-input
                                                                    "
                                                                    type="checkbox"
                                                                    id="isCatchUp"
                                                                    v-model="
                                                                        form.isCatchUp
                                                                    "
                                                                />&nbsp;&nbsp;
                                                                <label
                                                                    class="
                                                                        form-check-label
                                                                    "
                                                                    for="isCatchUp"
                                                                    >Is
                                                                    CatchUp?</label
                                                                >
                                                            </div>
                                                            <div
                                                                class="
                                                                    mt-3
                                                                    mx-2
                                                                    mb-2
                                                                "
                                                                v-if="
                                                                    form.isCatchUp
                                                                "
                                                            >
                                                                <div
                                                                    class="
                                                                        mb-3
                                                                    "
                                                                >
                                                                    <label
                                                                        for="previousWork"
                                                                        >Previous
                                                                        Work
                                                                    </label>
                                                                    <b-input-group>
                                                                        <template
                                                                            #append
                                                                        >
                                                                            <b-button
                                                                                @click="
                                                                                    getWork
                                                                                "
                                                                                variant="outline-info"
                                                                                ><i
                                                                                    class="
                                                                                        mdi
                                                                                        mdi-clipboard-text-search-outline
                                                                                    "
                                                                                ></i
                                                                            ></b-button>
                                                                        </template>
                                                                        <input
                                                                            autocomplete="off"
                                                                            type="text"
                                                                            disabled
                                                                            placeholder="Search Previous Work..."
                                                                            class="
                                                                                form-control
                                                                            "
                                                                            :class="{
                                                                                'is-invalid':
                                                                                    submitted &&
                                                                                    $v
                                                                                        .previousWork
                                                                                        .name
                                                                                        .$error,
                                                                            }"
                                                                            v-model="
                                                                                previousWork.name
                                                                            "
                                                                        />
                                                                    </b-input-group>
                                                                    <div
                                                                        v-if="
                                                                            submitted &&
                                                                            $v
                                                                                .previousWork
                                                                                .name
                                                                                .$error
                                                                        "
                                                                        class="
                                                                            invalid-feedback
                                                                        "
                                                                    >
                                                                        <span
                                                                            v-if="
                                                                                !$v
                                                                                    .previousWork
                                                                                    .name
                                                                                    .required
                                                                            "
                                                                            >This
                                                                            value
                                                                            is
                                                                            required.</span
                                                                        >
                                                                    </div>
                                                                </div>
                                                                <!-- <div>
                                                                    <label
                                                                        for="catchUpPlans"
                                                                        >CatchUp
                                                                        Plans
                                                                    </label>
                                                                    <textarea
                                                                        id="catchUpPlans"
                                                                        rows="5"
                                                                        v-model="
                                                                            form.catchUpPlans
                                                                        "
                                                                        placeholder="Enter CatchUp Plans..."
                                                                        class="
                                                                            form-control
                                                                        "
                                                                    ></textarea>
                                                                </div> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mb-3">
                                                        <label for="name"
                                                            >API Name
                                                        </label>
                                                        <textarea
                                                            autocomplete="off"
                                                            id="name"
                                                            rows="5"
                                                            v-model="form.name"
                                                            placeholder="Enter API Name..."
                                                            class="form-control"
                                                            :class="{'is-invalid': submitted && $v.form.name.$error}"
                                                        ></textarea>
                                                        <div v-if="submitted && $v.form.name.$error" class="invalid-feedback">
                                                            <span v-if="!$v.form.name.required">This value is required.</span>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="mb-3">
                                                        <label for="description">Description</label>
                                                        <textarea
                                                            id="description"
                                                            rows="5"
                                                            v-model="form.description"
                                                            placeholder="Enter Description..."
                                                            class="form-control"
                                                            :class="{'is-invalid': submitted && $v.form.description.$error}"
                                                        ></textarea>
                                                        <div
                                                            v-if="
                                                                submitted &&
                                                                $v.form
                                                                    .description
                                                                    .$error
                                                            "
                                                            class="
                                                                invalid-feedback
                                                            "
                                                        >
                                                            <span
                                                                v-if="
                                                                    !$v.form
                                                                        .description
                                                                        .required
                                                                "
                                                                >This value
                                                                is
                                                                required.</span
                                                            >
                                                        </div>
                                                    </div>
                                                    <div class="mb-3">
                                                        <label
                                                            for="apiTypeId"
                                                            >API Type
                                                        </label>
                                                        <b-input-group>
                                                            <template
                                                                #append
                                                            >
                                                                <b-button
                                                                    @click="
                                                                        getApiType
                                                                    "
                                                                    variant="outline-info"
                                                                    ><i
                                                                        class="
                                                                            mdi
                                                                            mdi-clipboard-text-search-outline
                                                                        "
                                                                    ></i
                                                                ></b-button>
                                                            </template>
                                                            <input
                                                                autocomplete="off"
                                                                type="text"
                                                                disabled
                                                                placeholder="Search API Type..."
                                                                class="
                                                                    form-control
                                                                "
                                                                :class="{
                                                                    'is-invalid':
                                                                        submitted &&
                                                                        $v
                                                                            .form
                                                                            .apiTypeId
                                                                            .$error,
                                                                }"
                                                                v-model="
                                                                    apiType
                                                                "
                                                            />
                                                        </b-input-group>
                                                        <div
                                                            v-if="
                                                                submitted &&
                                                                $v.form
                                                                    .apiTypeId
                                                                    .$error
                                                            "
                                                            class="
                                                                invalid-feedback
                                                            "
                                                        >
                                                            <span
                                                                v-if="
                                                                    !$v.form
                                                                        .apiTypeId
                                                                        .required
                                                                "
                                                                >This value
                                                                is
                                                                required.</span
                                                            >
                                                        </div>
                                                    </div> -->
                                                    <!-- <div>
                                                            <label
                                                                for="scoreEfficiency"
                                                                >Score
                                                            </label>
                                                            <b-row
                                                                class="mb-3"
                                                            >
                                                                <b-col>
                                                                    <input
                                                                        autocomplete="off"
                                                                        id="scoreEfficiency"
                                                                        type="text"
                                                                        v-model="
                                                                            form.scoreEfficiency
                                                                        "
                                                                        placeholder="Enter Efficiency..."
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        :class="{
                                                                            'is-invalid':
                                                                                submitted &&
                                                                                $v
                                                                                    .form
                                                                                    .scoreEfficiency
                                                                                    .$error,
                                                                        }"
                                                                    />
                                                                    <div
                                                                        v-if="
                                                                            submitted &&
                                                                            $v
                                                                                .form
                                                                                .scoreEfficiency
                                                                                .$error
                                                                        "
                                                                        class="
                                                                            invalid-feedback
                                                                        "
                                                                    >
                                                                        <span
                                                                            v-if="
                                                                                !$v
                                                                                    .form
                                                                                    .scoreEfficiency
                                                                                    .required
                                                                            "
                                                                            >This
                                                                            value
                                                                            is
                                                                            required.</span
                                                                        >
                                                                        <span
                                                                            v-if="
                                                                                !$v
                                                                                    .form
                                                                                    .scoreEfficiency
                                                                                    .numeric
                                                                            "
                                                                            >This
                                                                            value
                                                                            should
                                                                            be
                                                                            a
                                                                            valid
                                                                            number.</span
                                                                        >
                                                                    </div>
                                                                    <small
                                                                        v-if="
                                                                            form.scoreEfficiency
                                                                        "
                                                                        >Efficiency</small
                                                                    >
                                                                </b-col>
                                                                <b-col>
                                                                    <input
                                                                        autocomplete="off"
                                                                        id="scoreQuality"
                                                                        type="text"
                                                                        v-model="
                                                                            form.scoreQuality
                                                                        "
                                                                        placeholder="Enter Quality..."
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        :class="{
                                                                            'is-invalid':
                                                                                submitted &&
                                                                                $v
                                                                                    .form
                                                                                    .scoreQuality
                                                                                    .$error,
                                                                        }"
                                                                    />
                                                                    <div
                                                                        v-if="
                                                                            submitted &&
                                                                            $v
                                                                                .form
                                                                                .scoreQuality
                                                                                .$error
                                                                        "
                                                                        class="
                                                                            invalid-feedback
                                                                        "
                                                                    >
                                                                        <span
                                                                            v-if="
                                                                                !$v
                                                                                    .form
                                                                                    .scoreQuality
                                                                                    .required
                                                                            "
                                                                            >This
                                                                            value
                                                                            is
                                                                            required.</span
                                                                        >
                                                                        <span
                                                                            v-if="
                                                                                !$v
                                                                                    .form
                                                                                    .scoreQuality
                                                                                    .numeric
                                                                            "
                                                                            >This
                                                                            value
                                                                            should
                                                                            be
                                                                            a
                                                                            valid
                                                                            number.</span
                                                                        >
                                                                    </div>
                                                                    <small
                                                                        v-if="
                                                                            form.scoreQuality
                                                                        "
                                                                        >Quality</small
                                                                    >
                                                                </b-col>
                                                                <b-col>
                                                                    <input
                                                                        autocomplete="off"
                                                                        id="scoreTimeliness"
                                                                        type="text"
                                                                        v-model="
                                                                            form.scoreTimeliness
                                                                        "
                                                                        placeholder="Enter Timelines..."
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        :class="{
                                                                            'is-invalid':
                                                                                submitted &&
                                                                                $v
                                                                                    .form
                                                                                    .scoreTimeliness
                                                                                    .$error,
                                                                        }"
                                                                    />
                                                                    <div
                                                                        v-if="
                                                                            submitted &&
                                                                            $v
                                                                                .form
                                                                                .scoreTimeliness
                                                                                .$error
                                                                        "
                                                                        class="
                                                                            invalid-feedback
                                                                        "
                                                                    >
                                                                        <span
                                                                            v-if="
                                                                                !$v
                                                                                    .form
                                                                                    .scoreTimeliness
                                                                                    .required
                                                                            "
                                                                            >This
                                                                            value
                                                                            is
                                                                            required.</span
                                                                        >
                                                                        <span
                                                                            v-if="
                                                                                !$v
                                                                                    .form
                                                                                    .scoreTimeliness
                                                                                    .numeric
                                                                            "
                                                                            >This
                                                                            value
                                                                            should
                                                                            be
                                                                            a
                                                                            valid
                                                                            number.</span
                                                                        >
                                                                    </div>
                                                                    <small
                                                                        v-if="
                                                                            form.scoreTimeliness
                                                                        "
                                                                        >Timelines</small
                                                                    >
                                                                </b-col>
                                                            </b-row>
                                                        </div> -->
                                                    <!-- </b-col> -->
                                                    <!-- <b-col>
                                                        <div class="mb-3">
                                                            <label
                                                                for="finalRemarks"
                                                                >Final
                                                                Remarks
                                                            </label>
                                                            <textarea
                                                                id="finalRemarks"
                                                                rows="3"
                                                                v-model="
                                                                    form.finalRemarks
                                                                "
                                                                placeholder="Enter Final Remarks..."
                                                                class="
                                                                    form-control
                                                                "
                                                                :class="{
                                                                    'is-invalid':
                                                                        submitted &&
                                                                        $v
                                                                            .form
                                                                            .finalRemarks
                                                                            .$error,
                                                                }"
                                                            ></textarea>
                                                            <div
                                                                v-if="
                                                                    submitted &&
                                                                    $v.form
                                                                        .finalRemarks
                                                                        .$error
                                                                "
                                                                class="
                                                                    invalid-feedback
                                                                "
                                                            >
                                                                <span
                                                                    v-if="
                                                                        !$v
                                                                            .form
                                                                            .finalRemarks
                                                                            .required
                                                                    "
                                                                    >This
                                                                    value is
                                                                    required.</span
                                                                >
                                                            </div>
                                                        </div>
                                                        <div class="mb-3">
                                                            <input
                                                                class="
                                                                    form-check-input
                                                                "
                                                                type="checkbox"
                                                                id="isCompleted"
                                                                v-model="
                                                                    form.isCompleted
                                                                "
                                                            />&nbsp;&nbsp;
                                                            <label
                                                                class="
                                                                    form-check-label
                                                                "
                                                                for="isCompleted"
                                                                >Is
                                                                Completed?</label
                                                            >
                                                        </div>
                                                        <div
                                                            class="mb-3"
                                                            v-if="
                                                                form.isCompleted
                                                            "
                                                        >
                                                            <label
                                                                for="dateCompleted"
                                                                >Date
                                                                Completed
                                                            </label>
                                                            <date-picker
                                                                v-model="
                                                                    form.dateCompleted
                                                                "
                                                                :first-day-of-week="
                                                                    1
                                                                "
                                                                lang="en"
                                                                placeholder="Enter Date Completed..."
                                                            ></date-picker>
                                                        </div>
                                                        <div
                                                            class="mb-3"
                                                            v-if="
                                                                !form.isCompleted
                                                            "
                                                        >
                                                            <input
                                                                class="
                                                                    form-check-input
                                                                "
                                                                type="checkbox"
                                                                id="isCatchUp"
                                                                v-model="
                                                                    form.isCatchUp
                                                                "
                                                            />&nbsp;&nbsp;
                                                            <label
                                                                class="
                                                                    form-check-label
                                                                "
                                                                for="isCatchUp"
                                                                >Is
                                                                CatchUp?</label
                                                            >
                                                        </div>
                                                        <div
                                                            class="mb-3"
                                                            v-if="
                                                                form.isCatchUp &&
                                                                !form.isCompleted
                                                            "
                                                        >
                                                            <label
                                                                for="catchUpPlans"
                                                                >CatchUp
                                                                Plans
                                                            </label>
                                                            <textarea
                                                                id="catchUpPlans"
                                                                rows="5"
                                                                v-model="
                                                                    form.catchUpPlans
                                                                "
                                                                placeholder="Enter CatchUp Plans..."
                                                                class="
                                                                    form-control
                                                                "
                                                            ></textarea>
                                                        </div>
                                                    </b-col> -->
                                                </b-row>
                                                <div class="modal-footer">
                                                    <button
                                                        type="submit"
                                                        class="
                                                            btn btn-primary
                                                        "
                                                    >
                                                        Save changes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        class="btn btn-link"
                                                        @click="hideModal"
                                                    >
                                                        Close
                                                    </button>
                                                </div>
                                            </form>
                                        </b-modal>
                                    </div>
                                    <template v-if="selectAllAPI">
                                        <div class="row mt-2">
                                            <div class="col-md-6">
                                                <div
                                                    id="tickets-table_length"
                                                    class="dataTables_length"
                                                >
                                                    <label
                                                        class="
                                                            d-inline-flex
                                                            align-items-center
                                                            mb-0
                                                        "
                                                    >
                                                        Show&nbsp;
                                                        <b-form-select
                                                            class="
                                                                form-select
                                                                form-select-sm
                                                                mx-1
                                                            "
                                                            v-model="perPage"
                                                            size="sm"
                                                            :options="
                                                                pageOptions
                                                            "
                                                        ></b-form-select
                                                        >&nbsp;entries
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div
                                                    id="tickets-table_filter"
                                                    class="
                                                        dataTables_filter
                                                        text-md-end
                                                    "
                                                >
                                                    <label
                                                        class="
                                                            d-inline-flex
                                                            align-items-center
                                                        "
                                                    >
                                                        Search:
                                                        <b-form-input
                                                            autocomplete="off"
                                                            v-model="filter"
                                                            type="search"
                                                            placeholder="Search..."
                                                            class="
                                                                form-control
                                                                form-control-sm
                                                                ms-2
                                                            "
                                                        ></b-form-input>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-2">
                                            <template v-if="tableBusy">
                                                <div class="d-flex justify-content-center align-items-center">
                                                    <div class="spinner-grow text-primary" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <b-tabs nav-class="nav-tabs-custom" content-class="pt-0 px-2 text-muted">
                                                    <b-tab v-for="x in filteredApis" :key="x.id">
                                                        <template v-slot:title>
                                                            {{x.key}}
                                                        </template>
                                                        <div v-for="(z, zIndex) in x.data" :key="`${x.id}Z-${zIndex}`" class="mt-2">
                                                            <hr v-if="zIndex != 0" class="py-0 my-1">
                                                            <div class="d-flex justify-content-between align-items-center">
                                                                <div>
                                                                    <span class="fs-5 text-yellow d-block text-hover cursor-pointer" @click="z.showApis = !z.showApis">{{z.target}}</span>
                                                                    <small>{{z.apis.length}} API's</small>
                                                                </div>
                                                                <div>
                                                                    <!-- <button type="button" class="btn btn-sm btn-info" @click="addApi(z)" v-if="!selectedTransfer.id"><i class="bx bx-plus"></i>Create API</button> -->
                                                                </div>
                                                            </div>
                                                            <template v-if="z.showApis">
                                                                <hr class="mt-1 mb-2">
                                                                <h5 no-body class="mb-2">{{x.data.length ? `List of API's` : 'No data found'}}</h5>
                                                                <template v-for="(w, wIndex) in filterApiCards(z.apis)">
                                                                    <div :key="`API-B-${w.id}`" class="ms-3">
                                                                        <b-card no-body :style="{zIndex: `${x.data.length - zIndex}${z.apis.length - wIndex}`}" class="mb-2 shadow-none border position-relative">
                                                                            <RawData :data="w" v-if="$store.state.decrypt.isAdmin()"/>
                                                                            <b-card-header>
                                                                                <div class="d-flex justify-content-between align-items-center">
                                                                                    <div>
                                                                                        <span class="d-block cursor-pointer text-hover" @click="goToPPMPAll(w, z)">{{w.name}}   
                                                                                            <sup v-if="w.departmentName" class="badge bg-purple">{{w.departmentName}}</sup>
                                                                                        </span>
                                                                                        <small>Total: {{w.totalResources}}</small>
                                                                                    </div>
                                                                                    <b-dropdown
                                                                                        id="dropdown-dropleft"
                                                                                        right
                                                                                        variant="link"
                                                                                        toggle-class="text-decoration-none"
                                                                                        menu-class="dropdown-menu-end"
                                                                                        no-caret
                                                                                        v-if="!selectedTransfer.id"
                                                                                    >
                                                                                        <template #button-content><i class="fas fa-ellipsis-v"></i></template>
                                                                                        <b-dropdown-item
                                                                                            @click="goToPPMPAll(w)"
                                                                                            variant="dark"
                                                                                        >
                                                                                            <i class="bx bx-notepad font-size-18 me-1"></i>Resources
                                                                                        </b-dropdown-item>
                                                                                        <!-- <b-dropdown-item
                                                                                            @click="updateItemAll(w, z)
                                                                                            "
                                                                                            variant="dark"
                                                                                            v-if="
                                                                                                row.item.status.toUpperCase() !== 'POSTED' &&
                                                                                                row.item.status.toUpperCase() !== 'APPROVED' &&
                                                                                                !row.item.priority && !selectedTransfer.id
                                                                                            "
                                                                                            ><i
                                                                                                class="
                                                                                                    bx
                                                                                                    bx-edit
                                                                                                    font-size-18
                                                                                                    me-1
                                                                                                "
                                                                                            ></i
                                                                                            >Edit</b-dropdown-item
                                                                                        >
                                                                                        <b-dropdown-item
                                                                                            @click="
                                                                                                deleteItem(
                                                                                                    row
                                                                                                )
                                                                                            "
                                                                                            variant="danger"
                                                                                            v-if="
                                                                                                row.item.status.toUpperCase() !==
                                                                                                    'POSTED' &&
                                                                                                row.item.status.toUpperCase() !==
                                                                                                    'APPROVED' &&
                                                                                                !row.item
                                                                                                    .priority &&
                                                                                                !selectedTransfer.id
                                                                                            "
                                                                                            ><i
                                                                                                class="
                                                                                                    mdi
                                                                                                    mdi-trash-can
                                                                                                    font-size-18
                                                                                                    me-1
                                                                                                "
                                                                                            ></i
                                                                                            >Delete</b-dropdown-item
                                                                                        >
                                                                                        <b-dropdown-item
                                                                                            v-if="
                                                                                                row.item.status.toUpperCase() !==
                                                                                                    'CREATED' &&
                                                                                                !selectedTransfer.id
                                                                                            "
                                                                                            @click="
                                                                                                viewApiLogs(
                                                                                                    row.item.id
                                                                                                )
                                                                                            "
                                                                                            variant="dark"
                                                                                            ><i
                                                                                                class="
                                                                                                    bx bx-menu-alt-right
                                                                                                    font-size-18
                                                                                                    me-1
                                                                                                "
                                                                                            ></i
                                                                                            >View Logs</b-dropdown-item
                                                                                        > -->
                                                                                        <b-dropdown-item
                                                                                            @click="printPPMPByApi(w.id)"
                                                                                            variant="purple"
                                                                                        >
                                                                                            <i class="bx bx-printer font-size-18 me-1"></i>Print PPMP
                                                                                        </b-dropdown-item>
                                                                                    </b-dropdown>
                                                                                    <div v-else class="text-center">
                                                                                        <small v-if="transferApiIfs(w)"><a href="javascript:void(0);" class="text-success hoverable-link text-nowrap" @click="selectTransferApi(w, z)">Transfer Here</a></small>
                                                                                        <small v-else class="text-muted">Can't transfer here</small>
                                                                                    </div>
                                                                                </div>
                                                                            </b-card-header>
                                                                        </b-card>
                                                                    </div>
                                                                </template>
                                                            </template>
                                                        </div>
                                                    </b-tab>
                                                </b-tabs>
                                            </template>
                                            <hr>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="row mt-4">
                                            <div class="col-sm-12 col-md-6">
                                                <div
                                                    id="tickets-table_length"
                                                    class="dataTables_length"
                                                >
                                                    <label
                                                        class="
                                                            d-inline-flex
                                                            align-items-center
                                                        "
                                                    >
                                                        Show&nbsp;
                                                        <b-form-select
                                                            class="
                                                                form-select
                                                                form-select-sm
                                                                mx-1
                                                            "
                                                            v-model="perPage"
                                                            size="sm"
                                                            :options="
                                                                pageOptions
                                                            "
                                                        ></b-form-select
                                                        >&nbsp;entries
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- Search -->
                                            <div class="col-sm-12 col-md-6">
                                                <div
                                                    id="tickets-table_filter"
                                                    class="
                                                        dataTables_filter
                                                        text-md-end
                                                    "
                                                >
                                                    <label
                                                        class="
                                                            d-inline-flex
                                                            align-items-center
                                                        "
                                                    >
                                                        Search:
                                                        <b-form-input
                                                            autocomplete="off"
                                                            v-model="filter"
                                                            type="search"
                                                            placeholder="Search..."
                                                            class="
                                                                form-control
                                                                form-control-sm
                                                                ms-2
                                                            "
                                                        ></b-form-input>
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End search -->
                                        </div>
                                        <div class="table-responsive mb-0">
                                            <b-table
                                                class="datatables"
                                                :items="targetData"
                                                :fields="fields"
                                                responsive="sm"
                                                :per-page="perPage"
                                                :current-page="currentPage"
                                                :sort-by.sync="sortBy"
                                                :sort-desc.sync="sortDesc"
                                                :filter="filter"
                                                :filter-included-fields="
                                                    filterOn
                                                "
                                                :busy="tableBusy"
                                                @filtered="onFiltered"
                                                bordered
                                                outlined
                                                hover
                                                striped
                                                show-empty
                                            >
                                                <template #empty="scope">
                                                    <div class="text-center">
                                                        {{ scope.emptyText }}
                                                    </div>
                                                </template>
                                                <template #table-busy>
                                                    <div
                                                        class="
                                                            d-flex
                                                            justify-content-center
                                                            align-items-center
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                preloader-component
                                                                me-2
                                                            "
                                                        >
                                                            <div class="status">
                                                                <div
                                                                    class="
                                                                        spinner-chase
                                                                        w-20px
                                                                        h-20px
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <strong
                                                            >Loading...</strong
                                                        >
                                                    </div>
                                                </template>
                                                <template #cell(name)="data">
                                                    <a
                                                        href="javascript:void(0);" class="d-inline"
                                                        v-if="!selectedTransfer.id"
                                                        @click="
                                                            goToPPMP(data.item)
                                                        "
                                                    >
                                                        <div class="d-inline">
                                                            <b
                                                                class="text-white "
                                                                :id="`${data.item.id}`"
                                                                >{{
                                                                    data.item.name
                                                                }}</b
                                                            >
                                                        </div>
                                                        <div class="d-inline" style="vertical-align: super;">
                                                            <span
                                                                class="
                                                                    badge
                                                                    rounded-pill
                                                                    bg-danger
                                                                "
                                                                style="
                                                                    font-size: 8px;
                                                                "
                                                                >{{
                                                                    data.item
                                                                        .notification >
                                                                    0
                                                                        ? data
                                                                                .item
                                                                                .notification
                                                                        : ""
                                                                }}</span
                                                            >
                                                        </div>
                                                    </a>
                                                    <div v-else>
                                                        <a
                                                            href="javascript:void(0);"
                                                            class="
                                                                d-inline
                                                            "
                                                            v-if="transferApiIfs(data.item)"
                                                            @click="
                                                                selectTransferApi(data.item)
                                                            "
                                                        >
                                                            <b
                                                                class="text-white"
                                                                :id="`${data.item.id}`"
                                                                >{{
                                                                    data.item.name
                                                                }}</b
                                                            >
                                                            <div class="d-inline" style="vertical-align: super;">
                                                                <span
                                                                    class="
                                                                        badge
                                                                        rounded-pill
                                                                        bg-danger
                                                                    "
                                                                    style="
                                                                        font-size: 8px;
                                                                    "
                                                                    >{{
                                                                        data.item
                                                                            .notification >
                                                                        0
                                                                            ? data
                                                                                .item
                                                                                .notification
                                                                            : ""
                                                                    }}</span
                                                                >
                                                            </div>
                                                        </a>
                                                        <div v-else class="d-flex justify-content-start">
                                                            <b
                                                                class="text-white"
                                                                :id="`${data.item.id}`"
                                                                >{{
                                                                    data.item.name
                                                                }}</b
                                                            >
                                                            <div>
                                                                <span
                                                                    class="
                                                                        badge
                                                                        rounded-pill
                                                                        bg-danger
                                                                        float-end
                                                                    "
                                                                    style="
                                                                        font-size: 8px;
                                                                    "
                                                                    >{{
                                                                        data.item
                                                                            .notification >
                                                                        0
                                                                            ? data
                                                                                .item
                                                                                .notification
                                                                            : ""
                                                                    }}</span
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="text-muted">
                                                        {{
                                                            data.item
                                                                .description
                                                        }}
                                                    </div>
                                                    <div class="d-flex align-items-center">
                                                        <a href="javascript:void(0);" :id="`target-info-${data.item.id}`" class="text-green" v-if="selectAllAPI">
                                                            <i class="bx bx-info-circle"></i> Target
                                                        </a>
                                                        <b-popover
                                                            :target="`target-info-${data.item.id}`"
                                                            triggers="hover"
                                                            placement="right"
                                                            v-if="selectAllAPI"
                                                        >
                                                            {{ data.item.target.remarks }}
                                                        </b-popover>
                                                        <span class="mx-2" v-if="selectAllAPI">|</span>
                                                        <a
                                                            href="javascript:void(0);"
                                                            @click="showDtls(data)"
                                                            v-if="!selectedTransfer.id"
                                                        >
                                                            <i
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                "
                                                            >
                                                                <i
                                                                    class="
                                                                        bx
                                                                        bx-paperclip
                                                                        me-1
                                                                    "
                                                                ></i>
                                                                <span class="me-1"
                                                                    >Attachments</span
                                                                >
                                                                <i
                                                                    class="
                                                                        bx bx-play
                                                                        me-1
                                                                        font-size-15
                                                                        rotate
                                                                    "
                                                                    :class="{
                                                                        'rotate-90':
                                                                            data
                                                                                .item
                                                                                .showAttachments,
                                                                    }"
                                                                ></i>
                                                            </i>
                                                        </a>
                                                    </div>
                                                </template>
                                                <template #cell(status)="data">
                                                    <div>
                                                        <span>Status: </span>
                                                        <template
                                                            v-if="
                                                                data.value.toUpperCase() ===
                                                                'POSTED'
                                                            "
                                                        >
                                                            <span
                                                                class="
                                                                    badge
                                                                    bg-success
                                                                    font-size-12
                                                                "
                                                                >{{
                                                                    data.value
                                                                }}</span
                                                            >
                                                        </template>
                                                        <template
                                                            v-else-if="
                                                                data.value.toUpperCase() ===
                                                                'APPROVED'
                                                            "
                                                        >
                                                            <span
                                                                class="
                                                                    badge
                                                                    bg-success
                                                                    bg-soft
                                                                    font-size-12
                                                                    text-white
                                                                "
                                                                >{{
                                                                    data.value
                                                                }}</span
                                                            >
                                                        </template>
                                                        <template
                                                            v-else-if="
                                                                data.value.toUpperCase() ===
                                                                'RETURN'
                                                            "
                                                        >
                                                            <span
                                                                class="
                                                                    badge
                                                                    bg-warning
                                                                    bg-soft
                                                                    font-size-12
                                                                    text-warning
                                                                "
                                                                >{{
                                                                    data.value
                                                                }}</span
                                                            >
                                                        </template>
                                                        <template v-else>
                                                            {{ data.value }}
                                                        </template>
                                                    </div>
                                                    <div class="mt-1">
                                                        Planning:
                                                        <template
                                                            v-if="
                                                                data.item
                                                                    .planningStatus
                                                            "
                                                        >
                                                            <template
                                                                v-if="
                                                                    data.item.planningStatus.toUpperCase() ===
                                                                    'APPROVED'
                                                                "
                                                            >
                                                                <span
                                                                    class="
                                                                        badge
                                                                        bg-success
                                                                        bg-soft
                                                                        font-size-12
                                                                        text-white
                                                                    "
                                                                    >{{
                                                                        data
                                                                            .item
                                                                            .planningStatus
                                                                    }}</span
                                                                >
                                                            </template>
                                                            <template
                                                                v-else-if="
                                                                    data.item.planningStatus.toUpperCase() ===
                                                                    'RETURN'
                                                                "
                                                            >
                                                                <span
                                                                    class="
                                                                        badge
                                                                        bg-warning
                                                                        bg-soft
                                                                        font-size-12
                                                                        text-warning
                                                                    "
                                                                    >{{
                                                                        data
                                                                            .item
                                                                            .planningStatus
                                                                    }}</span
                                                                >
                                                            </template>
                                                            <template v-else>
                                                                {{
                                                                    data.item
                                                                        .planningStatus
                                                                }}
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            PENDING
                                                        </template>
                                                    </div>
                                                    <div class="mt-1">
                                                        Financial:
                                                        <template
                                                            v-if="
                                                                data.item
                                                                    .financialStatus
                                                            "
                                                        >
                                                            <template
                                                                v-if="
                                                                    data.item.financialStatus.toUpperCase() ===
                                                                    'APPROVED'
                                                                "
                                                            >
                                                                <span
                                                                    class="
                                                                        badge
                                                                        bg-success
                                                                        bg-soft
                                                                        font-size-12
                                                                        text-white
                                                                    "
                                                                    >{{
                                                                        data
                                                                            .item
                                                                            .financialStatus
                                                                    }}</span
                                                                >
                                                            </template>
                                                            <template
                                                                v-else-if="
                                                                    data.item.financialStatus.toUpperCase() ===
                                                                    'RETURN'
                                                                "
                                                            >
                                                                <span
                                                                    class="
                                                                        badge
                                                                        bg-warning
                                                                        bg-soft
                                                                        font-size-12
                                                                        text-warning
                                                                    "
                                                                    >{{
                                                                        data
                                                                            .item
                                                                            .financialStatus
                                                                    }}</span
                                                                >
                                                            </template>
                                                            <template v-else>
                                                                {{
                                                                    data.item
                                                                        .financialStatus
                                                                }}
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            PENDING
                                                        </template>
                                                    </div>
                                                </template>
                                                <template
                                                    #cell(catchUpPlans)="data"
                                                >
                                                    <div class="text-muted">
                                                        {{
                                                            data.item.isCatchUp
                                                                ? data.value
                                                                : "N/A"
                                                        }}
                                                    </div>
                                                </template>
                                                <template #cell(score)="data">
                                                    <div>
                                                        <b>Efficiency:</b
                                                        >&nbsp;{{
                                                            data.item
                                                                .scoreEfficiency
                                                        }}
                                                    </div>
                                                    <div>
                                                        <b>Quality:</b>&nbsp;{{
                                                            data.item
                                                                .scoreQuality
                                                        }}
                                                    </div>
                                                    <div>
                                                        <b>Timeliness:</b
                                                        >&nbsp;{{
                                                            data.item
                                                                .scoreTimeliness
                                                        }}
                                                    </div>
                                                </template>
                                                <template #cell(actions)="row">
                                                    <div class="float-end" v-if="!selectedTransfer.id">
                                                        <b-dropdown
                                                            id="dropdown-dropleft"
                                                            right
                                                            variant="link"
                                                            toggle-class="text-decoration-none"
                                                            menu-class="dropdown-menu-end"
                                                            no-caret
                                                        >
                                                            <template
                                                                #button-content
                                                            >
                                                                <i
                                                                    class="
                                                                        fas
                                                                        fa-ellipsis-v
                                                                    "
                                                                ></i>
                                                            </template>

                                                            <b-dropdown-item
                                                                @click="
                                                                    goToPPMP(
                                                                        row.item
                                                                    )
                                                                "
                                                                variant="dark"
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-notepad
                                                                        font-size-18
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Resources</b-dropdown-item
                                                            >
                                                            <b-dropdown-item
                                                                @click="
                                                                    updateItem(
                                                                        row
                                                                    )
                                                                "
                                                                variant="dark"
                                                                v-if="
                                                                    row.item.status.toUpperCase() !== 'POSTED' &&
                                                                    row.item.status.toUpperCase() !== 'APPROVED' &&
                                                                    !row.item.priority && !selectedTransfer.id
                                                                "
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-edit
                                                                        font-size-18
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Edit</b-dropdown-item
                                                            >
                                                            <b-dropdown-item
                                                                @click="
                                                                    deleteItem(
                                                                        row
                                                                    )
                                                                "
                                                                variant="danger"
                                                                v-if="
                                                                    row.item.status.toUpperCase() !==
                                                                        'POSTED' &&
                                                                    row.item.status.toUpperCase() !==
                                                                        'APPROVED' &&
                                                                    !row.item
                                                                        .priority &&
                                                                    !selectedTransfer.id
                                                                "
                                                                ><i
                                                                    class="
                                                                        mdi
                                                                        mdi-trash-can
                                                                        font-size-18
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Delete</b-dropdown-item
                                                            >
                                                            <b-dropdown-item
                                                                v-if="
                                                                    row.item.status.toUpperCase() !==
                                                                        'CREATED' &&
                                                                    !selectedTransfer.id
                                                                "
                                                                @click="
                                                                    viewApiLogs(
                                                                        row.item.id
                                                                    )
                                                                "
                                                                variant="dark"
                                                                ><i
                                                                    class="
                                                                        bx bx-menu-alt-right
                                                                        font-size-18
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >View Logs</b-dropdown-item
                                                            >
                                                            <b-dropdown-item
                                                                @click="
                                                                    printPPMPByApi(
                                                                        row.item.id
                                                                    )
                                                                "
                                                                variant="purple"
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-printer
                                                                        font-size-18
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Print PPMP</b-dropdown-item
                                                            >
                                                            <b-dropdown-item
                                                                v-if="
                                                                    row.item.status.toUpperCase() !==
                                                                        'POSTED' &&
                                                                    row.item.status.toUpperCase() !==
                                                                        'APPROVED' &&
                                                                    !selectedTransfer.id
                                                                "
                                                                @click="
                                                                    postPPMP(
                                                                        row.item
                                                                    )
                                                                "
                                                                variant="success"
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-check
                                                                        font-size-18
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Post this
                                                                Work</b-dropdown-item
                                                            >
                                                        </b-dropdown>
                                                    </div>
                                                    <div v-else class="text-center">
                                                        <small v-if="transferApiIfs(row.item)"><a href="javascript:void(0);" class="text-success hoverable-link text-nowrap" @click="selectTransferApi(row.item)">Transfer Here</a></small>
                                                        <small v-else class="text-muted">Can't transfer here</small>
                                                    </div>
                                                </template>
                                                <template #row-details="row">
                                                    <transition
                                                        name="max-height"
                                                    >
                                                        <div
                                                            v-if="
                                                                row.item
                                                                    .showAttachments
                                                            "
                                                        >
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    justify-content-between
                                                                    align-items-center
                                                                "
                                                            >
                                                                <div>
                                                                    <input
                                                                        type="search"
                                                                        class="
                                                                            form-control
                                                                            form-control-sm
                                                                        "
                                                                        placeholder="Search Attachments"
                                                                        v-model="
                                                                            row
                                                                                .item
                                                                                .fileSearch
                                                                        "
                                                                        @input="
                                                                            searchDocu(
                                                                                row.item
                                                                            )
                                                                        "
                                                                    />
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    class="
                                                                        btn
                                                                        btn-outline-success
                                                                        no-wrap
                                                                        btn-sm
                                                                    "
                                                                    :id="`api-document${row.item.id}`"
                                                                    @click="
                                                                        row.item.addDocu = true
                                                                    "
                                                                >
                                                                    <i
                                                                        class="
                                                                            bx
                                                                            bx-upload
                                                                            me-1
                                                                        "
                                                                    ></i>
                                                                    Upload
                                                                    Document
                                                                </button>
                                                                <upload-popover
                                                                    :option="
                                                                        uploadOptions
                                                                    "
                                                                    :sourceId="
                                                                        row.item
                                                                            .id
                                                                    "
                                                                    @uploaded="
                                                                        uploadedDocument(
                                                                            $event,
                                                                            row
                                                                                .item
                                                                                .id
                                                                        )
                                                                    "
                                                                    :showPV="
                                                                        row.item
                                                                            .addDocu
                                                                    "
                                                                    @closePopover="
                                                                        row.item.addDocu = false
                                                                    "
                                                                    :dzId="`dropzone-api${row.item.id}`"
                                                                    :pvId="`api-document${row.item.id}`"
                                                                ></upload-popover>
                                                            </div>
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    justify-content-center
                                                                    align-items-center
                                                                "
                                                                v-if="
                                                                    row.item
                                                                        .attachmentLoading
                                                                "
                                                            >
                                                                <div
                                                                    class="
                                                                        preloader-component
                                                                        me-2
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            status
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                spinner-chase
                                                                                w-20px
                                                                                h-20px
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <strong
                                                                    >Loading...</strong
                                                                >
                                                            </div>
                                                            <div
                                                                class="row"
                                                                v-if="
                                                                    !row.item
                                                                        .attachmentLoading
                                                                "
                                                            >
                                                                <div
                                                                    class="
                                                                        col-md-4
                                                                        mb-2
                                                                    "
                                                                    v-for="(
                                                                        y, index
                                                                    ) in searchDocu(
                                                                        row.item
                                                                    )"
                                                                    :key="y.id"
                                                                >
                                                                    <div
                                                                        class="
                                                                            position-relative
                                                                            cursor-pointer
                                                                            border
                                                                            mt-2
                                                                            border-secondary
                                                                            br-5
                                                                        "
                                                                        :style="`z-index: ${
                                                                            searchDocu(
                                                                                row.item
                                                                            )
                                                                                .length -
                                                                            index
                                                                        }`"
                                                                    >
                                                                        <div
                                                                            class="
                                                                                border
                                                                                p-3
                                                                            "
                                                                        >
                                                                            <div>
                                                                                <div
                                                                                    class="
                                                                                        float-end
                                                                                        ms-2
                                                                                    "
                                                                                >
                                                                                    <b-dropdown
                                                                                        id="dropdown-dropleft"
                                                                                        right
                                                                                        variant="link"
                                                                                        toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                                        menu-class="dropdown-menu-end"
                                                                                        no-caret
                                                                                    >
                                                                                        <template
                                                                                            #button-content
                                                                                        >
                                                                                            <i
                                                                                                class="
                                                                                                    mdi
                                                                                                    mdi-dots-horizontal
                                                                                                "
                                                                                            ></i>
                                                                                        </template>
                                                                                        <b-dropdown-item
                                                                                            @click="
                                                                                                openDocument(
                                                                                                    y
                                                                                                )
                                                                                            "
                                                                                            ><i
                                                                                                class="
                                                                                                    bx
                                                                                                    bx-link-external
                                                                                                    me-1
                                                                                                "
                                                                                            ></i
                                                                                            >Open</b-dropdown-item
                                                                                        >
                                                                                        <b-dropdown-item
                                                                                            variant="danger"
                                                                                            @click="
                                                                                                removeFile(
                                                                                                    y.id,
                                                                                                    row
                                                                                                        .item
                                                                                                        .id
                                                                                                )
                                                                                            "
                                                                                            ><i
                                                                                                class="
                                                                                                    bx
                                                                                                    bx-trash
                                                                                                    me-1
                                                                                                "
                                                                                            ></i
                                                                                            >Remove</b-dropdown-item
                                                                                        >
                                                                                    </b-dropdown>
                                                                                </div>
                                                                                <div
                                                                                    class="
                                                                                        avatar-xs
                                                                                        me-3
                                                                                        mb-2
                                                                                    "
                                                                                    @click="
                                                                                        openDocument(
                                                                                            y
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="
                                                                                            avatar-title
                                                                                            bg-transparent
                                                                                            rounded
                                                                                        "
                                                                                    >
                                                                                        <i
                                                                                            v-if="
                                                                                                y.fileType.includes(
                                                                                                    'image'
                                                                                                )
                                                                                            "
                                                                                            class="
                                                                                                mdi
                                                                                                mdi-image
                                                                                                font-size-24
                                                                                                text-purple
                                                                                            "
                                                                                        ></i>
                                                                                        <i
                                                                                            v-if="
                                                                                                y.fileType.includes(
                                                                                                    'application'
                                                                                                )
                                                                                            "
                                                                                            class="
                                                                                                mdi
                                                                                                mdi-file-pdf-outline
                                                                                                font-size-24
                                                                                                text-danger
                                                                                            "
                                                                                        ></i>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    class="
                                                                                        d-flex
                                                                                    "
                                                                                    @click="
                                                                                        openDocument(
                                                                                            y
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="
                                                                                            overflow-hidden
                                                                                            me-auto
                                                                                        "
                                                                                    >
                                                                                        <h5
                                                                                            class="
                                                                                                font-size-14
                                                                                                text-truncate
                                                                                                mb-1
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                y.description
                                                                                            }}
                                                                                        </h5>
                                                                                        <p
                                                                                            class="
                                                                                                text-muted
                                                                                                mb-0
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                formatDateWithTime(
                                                                                                    new Date(
                                                                                                        y.dateTimeUploaded
                                                                                                    )
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        col-md-12
                                                                        text-center
                                                                        mt-2
                                                                    "
                                                                    v-if="
                                                                        searchDocu(
                                                                            row.item
                                                                        )
                                                                            .length ==
                                                                            0 &&
                                                                        row.item
                                                                            .attachments
                                                                            .length >
                                                                            0
                                                                    "
                                                                >
                                                                    Search Not
                                                                    Found
                                                                </div>
                                                                <div
                                                                    class="
                                                                        col-md-12
                                                                        text-center
                                                                        mt-2
                                                                    "
                                                                    v-if="
                                                                        row.item
                                                                            .attachments
                                                                            .length ==
                                                                        0
                                                                    "
                                                                >
                                                                    No Document
                                                                    Found
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </transition>
                                                </template>
                                            </b-table>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <div
                                                    class="
                                                        dataTables_paginate
                                                        paging_simple_numbers
                                                        float-end
                                                    "
                                                >
                                                    <ul
                                                        class="
                                                            pagination
                                                            pagination-rounded
                                                            mb-0
                                                        "
                                                    >
                                                        <!-- pagination -->
                                                        <b-pagination
                                                            v-model="
                                                                currentPage
                                                            "
                                                            :total-rows="rows"
                                                            :per-page="perPage"
                                                        ></b-pagination>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <div >
                        <div class="row">
                            <b-col sm="6">
                                <div class="d-flex align-items-center">
                                    <a
                                        href="javascript:void(0);"
                                        class="me-1"
                                        @click="returnToApi"
                                        ><i
                                            class="
                                                bx bx-left-arrow-alt
                                                fs-2
                                            "
                                        ></i
                                    ></a>
                                    <div>
                                        <h4 class="m-0">
                                            {{ selectedApi }}'s Items
                                        </h4>
                                    </div>
                                </div>
                            </b-col>
                            <b-col sm="6" class="text-right">
                                <h4 class="text-muted mb-0">
                                    <div class="">
                                        Total:
                                        <b class="text-warning">{{
                                            formatCurrency(totalResourceItemAmt())
                                        }}</b>
                                    </div>
                                </h4>
                            </b-col>
                        </div>
                        <b-row>
                            <b-col sm="12" class="mt-2">
                                <div class="row">
                                    <div class="col-md-6 d-flex">
                                        <div
                                            id="tickets-table_filter"
                                            class="dataTables_filter me-1"
                                        >
                                            <label
                                                class="
                                                    d-inline-flex
                                                    align-items-center
                                                "
                                            >
                                                <b-form-input
                                                    autocomplete="off"
                                                    v-model="filterItem"
                                                    type="search"
                                                    placeholder="Search Items..."
                                                    class="form-control"
                                                ></b-form-input>
                                            </label>
                                        </div>
                                        <div
                                            id="tickets-table_length"
                                            class="dataTables_length"
                                        >
                                            <label
                                                class="
                                                    d-inline-flex
                                                    align-items-center
                                                    mb-0
                                                "
                                            >
                                                <b-form-select
                                                    class="form-select"
                                                    v-model="perPageResource"
                                                    size="sm"
                                                    :options="pageOptions"
                                                ></b-form-select>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <b-dropdown
                                            id="dropdown-dropleft"
                                            right
                                            variant="outline-dark"
                                            toggle-class="text-decoration-none"
                                            menu-class="dropdown-menu-end"
                                            no-caret
                                            v-if="$store.state.decrypt.isAdmin()"
                                        >
                                            <template #button-content>
                                                <i class="bx bx-filter"></i>
                                            </template>
                                            <b-dropdown-item @click="filterChildParent = 0"><span :class="{'text-success': filterChildParent == 0}">All</span></b-dropdown-item>
                                            <b-dropdown-item @click="filterChildParent = 1"><span :class="{'text-success': filterChildParent == 1}">Parent</span></b-dropdown-item>
                                            <b-dropdown-item @click="filterChildParent = 2"><span :class="{'text-success': filterChildParent == 2}">Child</span></b-dropdown-item>
                                        </b-dropdown>
                                        <!-- <button type="button" class="align-items-center float-end btn btn-outline-dark" v-if="$store.state.decrypt.isAdmin()" @click="">
                                            <i class="bx bx-filter"></i>
                                        </button> -->
                                        <button
                                            class="
                                                btn btn-info
                                                d-flex
                                                align-items-center
                                                float-end
                                                mx-1
                                            "
                                            @click="addNewItem"
                                            v-if="(!selectedPPMPStatus.toUpperCase().includes('POST') && !selectedPPMPStatus.toUpperCase().includes('APPROVED')) || $store.state.decrypt.isAdmin()"
                                        >
                                            <i class="bx bx-plus me-1"></i>
                                            Create New
                                        </button>
                                        <!-- <button
                                            class="
                                                btn btn-gradient-primary
                                                d-flex
                                                align-items-center
                                                float-end
                                                mx-1
                                            "
                                            @click="importNewItem"
                                            v-if="
                                                selectedPPMPStatus !==
                                                    'POSTED' &&
                                                selectedPPMPStatus !==
                                                    'APPROVED'
                                            "
                                        >
                                            <i
                                                class="bx bx-download me-1"
                                            ></i>
                                            Import from Pre-planning
                                        </button> -->
                                        <button
                                            class="
                                                btn btn-success
                                                d-flex
                                                align-items-center
                                                float-end
                                                mx-1
                                            "
                                            @click="postWork"
                                            v-if="
                                                selectedPPMPStatus !==
                                                    'POSTED' &&
                                                selectedPPMPStatus !==
                                                    'APPROVED'
                                            "
                                        >
                                            <i class="bx bx-check me-1"></i>
                                            Post this Work
                                        </button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <div class="table-responsive">
                                                <table
                                                    class="
                                                        table
                                                        project-list-table
                                                        table-centered
                                                        table-borderless
                                                        align-middle
                                                        resource-item-table
                                                    "
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th width="20px"></th>
                                                            <th scope="col">Item Name</th>
                                                            <th scope="col">Description</th>
                                                            <th scope="col" width="150px" class="text-center">Quantity</th>
                                                            <th scope="col" width="150px">Unit Cost</th>
                                                            <th scope="col" width="150px">Total</th>
                                                            <th scope="col" width="100px" class="text-center">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-if="itemLoading">
                                                            <td colspan="7">
                                                                <div class="d-flex justify-content-center align-items-center">
                                                                    <div class="preloader-component me-2">
                                                                        <div class="status">
                                                                            <div class="spinner-chase w-20px h-20px">
                                                                                <div class="chase-dot"></div>
                                                                                <div class="chase-dot"></div>
                                                                                <div class="chase-dot"></div>
                                                                                <div class="chase-dot"></div>
                                                                                <div class="chase-dot"></div>
                                                                                <div class="chase-dot"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <strong>Loading...</strong>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="resourceItems.length == 0 && !itemLoading">
                                                            <td colspan="7" class="text-muted text-center">
                                                                <i class="dripicons-warning me-1"></i>No data found
                                                            </td>
                                                        </tr>
                                                        <tr v-if="resourceItems.length > 0 && !itemLoading && filteredResourceItems.length == 0">
                                                            <td colspan="7" class="text-muted text-center">
                                                                <i class="dripicons-warning me-1"></i>Search not found
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            v-for="x in filteredResourceItems"
                                                            :key="x.id"
                                                            :ref="`resource-tr-${x.id}`"
                                                            style="background-color: transparent; box-shadow: none;"
                                                        >
                                                            <td v-if="x.mixParentId > 0"><i class="bx bx-right-arrow-alt"></i></td>
                                                            <td
                                                                class="
                                                                    border
                                                                    border-end-0
                                                                    position-relative
                                                                    bg-table-tr
                                                                "
                                                                :colspan="x.mixParentId > 0 ? 1 : 2"
                                                                :class="{
                                                                    'border-success': x.technicalReviewStatus.toUpperCase().includes('APPROVED'),
                                                                    'border-warning': x.technicalReviewStatus.toUpperCase().includes('RETURN'),
                                                                }"
                                                            >
                                                                <RawData :data="x" v-if="$store.state.decrypt.isAdmin()"/>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            me-2
                                                                        "
                                                                    >
                                                                        <div
                                                                            style="
                                                                                height: 50px;
                                                                                width: 50px;
                                                                            "
                                                                            class="
                                                                                bg-secondary
                                                                                cursor-pointer
                                                                            "
                                                                            @click="
                                                                                updateProfile(
                                                                                    x
                                                                                )
                                                                            "
                                                                        >
                                                                            <img
                                                                                :src="
                                                                                    x.thumbnailUrl
                                                                                "
                                                                                v-if="
                                                                                    x.thumbnail
                                                                                "
                                                                                class="
                                                                                    img-fluid
                                                                                "
                                                                                style="
                                                                                    height: 50px;
                                                                                    width: 50px;
                                                                                "
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            {{
                                                                                x.itemName
                                                                            }}
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                mb-1
                                                                            "
                                                                        >
                                                                            <small
                                                                                ><i
                                                                                    >{{
                                                                                        x
                                                                                            .itemCategory
                                                                                            .name
                                                                                    }}</i
                                                                                >
                                                                                <span class="text-warning ms-1">[{{x.isProcurable ? 'Procurable' : 'Non-procurable' }}]</span>
                                                                                <span class="text-warning ms-1" v-if="x.isMixed">[Mixed]</span>
                                                                                <span class="text-warning ms-1 hover-underline cursor-pointer" v-if="x.mixParentId > 0" :id="`child-item-${x.id}`">[Child]</span>
                                                                                <b-popover
                                                                                    :target="`child-item-${x.id}`"
                                                                                    triggers="click bliur"
                                                                                    placement="right"
                                                                                    v-if="x.mixParentId > 0"
                                                                                >
                                                                                    {{ x.mixParentItemName }}
                                                                                </b-popover>
                                                                                <span class="ms-1" v-if="x.itemCategory.itemCategoryGroup">{{x.itemCategory.itemCategoryGroup.technicalReviewUsers.length > 0 ? `[${x.itemCategory.itemCategoryGroup.technicalReviewUsers[0].applicationUser.completeName}]` : ''}}</span>
                                                                                </small
                                                                            >
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                d-flex
                                                                                align-items-center
                                                                                mb-1
                                                                            "
                                                                        >
                                                                            <span
                                                                                class="
                                                                                    badge
                                                                                    bg-secondary
                                                                                    text-white
                                                                                    py-1
                                                                                    px-2
                                                                                    me-2
                                                                                "
                                                                                >{{
                                                                                    x
                                                                                        .deliveryUnitBudgetItem
                                                                                        .fundSource
                                                                                }}</span
                                                                            >
                                                                            <span
                                                                                class="
                                                                                    badge
                                                                                    bg-purple
                                                                                    text-white
                                                                                    py-1
                                                                                    px-2
                                                                                "
                                                                                >{{
                                                                                    x
                                                                                        .deliveryUnitBudgetItem
                                                                                        .fundClass
                                                                                }}</span
                                                                            >
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                d-flex
                                                                                align-items-center
                                                                            "
                                                                        >
                                                                            <span
                                                                                class="
                                                                                    badge
                                                                                    bg-success
                                                                                    text-white
                                                                                    py-1
                                                                                    px-2
                                                                                    me-2
                                                                                "
                                                                                >{{
                                                                                    x
                                                                                        .deliveryUnitBudgetItem
                                                                                        .accountGroup
                                                                                }}</span
                                                                            >
                                                                            <span
                                                                                class="
                                                                                    badge
                                                                                    bg-primary
                                                                                    text-white
                                                                                    py-1
                                                                                    px-2
                                                                                "
                                                                                >{{
                                                                                    x
                                                                                        .deliveryUnitBudgetItem
                                                                                        .accountName
                                                                                }}</span
                                                                            >
                                                                        </div>
                                                                        <div class="mt-2">
                                                                            <div
                                                                                class="
                                                                                    form-check
                                                                                    form-checkbox-outline
                                                                                    form-check-success
                                                                                    mb-0
                                                                                "
                                                                            >
                                                                                <input
                                                                                    autocomplete="off"
                                                                                    class="
                                                                                        form-check-input
                                                                                    "
                                                                                    type="checkbox"
                                                                                    :id="`notify-${x.id}`"
                                                                                    v-model="
                                                                                        x.notify
                                                                                    "
                                                                                    @click="
                                                                                        notifyForUpdates(
                                                                                            x
                                                                                        )
                                                                                    "
                                                                                />&nbsp;&nbsp;
                                                                                <label
                                                                                    class="
                                                                                        form-check-label
                                                                                    "
                                                                                    :for="`notify-${x.id}`"
                                                                                    >Notify for Item Updates</label
                                                                                >
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td
                                                                class="
                                                                    border
                                                                    border-start-0
                                                                    border-end-0
                                                                    bg-table-tr
                                                                "
                                                                :class="{
                                                                    'border-success': x.technicalReviewStatus.toUpperCase().includes('APPROVED'),
                                                                    'border-warning': x.technicalReviewStatus.toUpperCase().includes('RETURN'),
                                                                }"
                                                            >
                                                                {{ x.description }}
                                                            </td>
                                                            <td
                                                                class="
                                                                    border
                                                                    border-start-0
                                                                    border-end-0
                                                                    text-center
                                                                    bg-table-tr
                                                                "
                                                                :class="{
                                                                    'border-success': x.technicalReviewStatus.toUpperCase().includes('APPROVED'),
                                                                    'border-warning': x.technicalReviewStatus.toUpperCase().includes('RETURN'),
                                                                }"
                                                            >
                                                                {{
                                                                    numberWithCommas(x.totalQuantity)
                                                                }}
                                                                <!-- edit quantity -->
                                                            </td>
                                                            <td
                                                                class="
                                                                    border
                                                                    border-start-0
                                                                    border-end-0
                                                                    bg-table-tr
                                                                "
                                                                :class="{
                                                                    'border-success':
                                                                        x.technicalReviewStatus
                                                                            .toUpperCase()
                                                                            .includes(
                                                                                'APPROVED'
                                                                            ),
                                                                    'border-warning':
                                                                        x.technicalReviewStatus
                                                                            .toUpperCase()
                                                                            .includes(
                                                                                'RETURN'
                                                                            ),
                                                                }"
                                                            >
                                                                {{
                                                                    formatCurrency(
                                                                        x.unitCost
                                                                    )
                                                                }}
                                                            </td>
                                                            <td
                                                                class="
                                                                    border
                                                                    border-start-0
                                                                    border-end-0
                                                                    bg-table-tr
                                                                "
                                                                :class="{
                                                                    'border-success':
                                                                        x.technicalReviewStatus
                                                                            .toUpperCase()
                                                                            .includes(
                                                                                'APPROVED'
                                                                            ),
                                                                    'border-warning':
                                                                        x.technicalReviewStatus
                                                                            .toUpperCase()
                                                                            .includes(
                                                                                'RETURN'
                                                                            ),
                                                                }"
                                                            >
                                                                {{
                                                                    formatCurrency(
                                                                        x.totalWithInflation
                                                                    )
                                                                }}
                                                                <div v-if="x.totalInflation > 0">
                                                                    <small>Inflation: {{formatCurrency(x.totalInflation)}}</small>
                                                                </div>
                                                                <div v-if="x.isMixed">
                                                                    <small class="text-warning">Mixed Amt. Remaining:</small>
                                                                    <div style="line-height:12px;">
                                                                        <small class="text-warning">{{formatCurrency(x.remaining)}}</small>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td
                                                                :class="{
                                                                    'border-success':
                                                                        x.technicalReviewStatus
                                                                            .toUpperCase()
                                                                            .includes(
                                                                                'APPROVED'
                                                                            ),
                                                                    'border-warning':
                                                                        x.technicalReviewStatus
                                                                            .toUpperCase()
                                                                            .includes(
                                                                                'RETURN'
                                                                            ),
                                                                }"
                                                                class="
                                                                    text-center
                                                                    border
                                                                    border-start-0
                                                                    bg-table-tr
                                                                "
                                                            >
                                                                <b-dropdown
                                                                    class="card-drop"
                                                                    menu-class="dropdown-menu-end"
                                                                    variant="white"
                                                                    toggle-class="p-0"
                                                                >
                                                                    <template v-slot:button-content>
                                                                        <i class="mdi  mdi-dots-horizontal font-size-18"></i>
                                                                    </template>
                                                                    <b-dropdown-item
                                                                        @click="resubmitItem(x)"
                                                                        variant="success"
                                                                        v-if="x.technicalReviewStatus.toUpperCase().includes('RETURN') && !x.isMixed"
                                                                    >
                                                                        <i class="bx bx-check font-size-18 me-1"></i>Resubmit Item
                                                                    </b-dropdown-item>
                                                                    <b-dropdown-item
                                                                        @click="viewItemLogs(x)"
                                                                        variant="dark"
                                                                    >
                                                                        <i class="bx bx-menu-alt-right font-size-18 me-1"></i>View Logs
                                                                    </b-dropdown-item>
                                                                    <!-- <b-dropdown-item
                                                                        @click="transferItem(x)"
                                                                        v-if="
                                                                            (selectedPPMPStatus !=='POSTED' && selectedPPMPStatus !== 'APPROVED') ||
                                                                            x.technicalReviewStatus.toUpperCase().includes('RETURN')
                                                                        "
                                                                        variant="success"
                                                                        >
                                                                        <i class="bx bx-send font-size-18 me-1"></i>Transfer to another API
                                                                    </b-dropdown-item> -->
                                                                    <template v-if="!x.mixParentId || x.mixParentId == 0">
                                                                        <b-dropdown-item
                                                                            @click="updateResourceItem(x)"
                                                                            v-if="
                                                                                (selectedPPMPStatus !== 'POSTED' && selectedPPMPStatus !== 'APPROVED') ||
                                                                                (x.technicalReviewStatus.toUpperCase().includes('RETURN') && !x.isMixed) || 
                                                                                $store.state.decrypt.isAdmin()
                                                                            "
                                                                            variant="dark"
                                                                        >
                                                                            <i class="bx bx-edit font-size-18 me-1"></i>Edit
                                                                        </b-dropdown-item>
                                                                    </template>
                                                                    <template v-else>
                                                                        <b-dropdown-item
                                                                            @click="updateMixResourceItem(x)"
                                                                            v-if="
                                                                                (selectedPPMPStatus !== 'POSTED' && selectedPPMPStatus !== 'APPROVED') ||
                                                                                (x.technicalReviewStatus.toUpperCase().includes('RETURN') && !x.isMixed) || 
                                                                                $store.state.decrypt.isAdmin()
                                                                            "
                                                                            variant="dark"
                                                                        >
                                                                            <i class="bx bx-edit font-size-18 me-1"></i>Edit
                                                                        </b-dropdown-item>
                                                                    </template>
                                                                    <b-dropdown-item
                                                                        @click="updateResourceItem(x, 'view')"
                                                                        variant="dark"
                                                                    >
                                                                        <i class="bx bx-food-menu font-size-18 me-1"></i>View Details
                                                                    </b-dropdown-item>
                                                                    <b-dropdown-item
                                                                        @click="transferToMother(x)"
                                                                        v-if="$store.state.decrypt.isAdmin()"
                                                                        variant="dark"
                                                                    >
                                                                        <i class="bx bx-chevron-left font-size-18 me-1"></i>Transfer to a Mother Resource
                                                                    </b-dropdown-item>
                                                                    <b-dropdown-item
                                                                        v-if="x.isMixed && !selectedTransfer.id"
                                                                        @click="createMixItem(x)"
                                                                        variant="primary"
                                                                    >
                                                                        <i class="bx bx-plus font-size-18 me-1"></i> Create Item
                                                                    </b-dropdown-item>
                                                                    <b-dropdown-item
                                                                        v-if="
                                                                            ($store.state.data.cycle == 2023 && selectedPPMPStatus !== 'POSTED' && selectedPPMPStatus !== 'APPROVED') ||
                                                                            ($store.state.data.cycle == 2023 && x.technicalReviewStatus.toUpperCase().includes('RETURN') && !x.isMixed) ||
                                                                            ($store.state.data.cycle != 2023 && !x.isMixed)
                                                                            || $store.state.decrypt.isAdmin()
                                                                        "
                                                                        @click="deleteResourceItem(x)"
                                                                        variant="danger"
                                                                    >
                                                                        <i class="mdi mdi-trash-can font-size-18 me-1"></i>Delete 
                                                                    </b-dropdown-item>
                                                                </b-dropdown>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col mb-3">
                                        <div
                                            class="
                                                dataTables_paginate
                                                paging_simple_numbers
                                                float-end
                                            "
                                        >
                                            <ul
                                                class="
                                                    pagination
                                                    pagination-rounded
                                                    mb-0
                                                "
                                            >
                                                <!-- pagination -->
                                                <b-pagination
                                                    v-model="
                                                        currentPageResource
                                                    "
                                                    :total-rows="
                                                        rowsResourceItem
                                                    "
                                                    :per-page="perPageResource"
                                                ></b-pagination>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
        <api-type @dropData="dropType($event)"></api-type>
        <api-resource-logs ref="itemlog"></api-resource-logs>
        <api-logs ref="apilog"></api-logs>
        <import-preplanning
            ref="preplanning"
            @dropData="dropImports"
        ></import-preplanning>
        <import-api ref="importapi" @dropData="dropImportedApi"></import-api>
        <back-log-modal
            ref="backlog"
            @dropData="dropWork($event)"
        ></back-log-modal>
        <print-options ref="printOpt"></print-options>
        <div v-if="selectedTransfer.id">
            <div
                class="position-fixed p-4"
                style="top: 125px; left: 50%; transform: translateX(-50%)"
            >
                <div>
                    <span class="bg-success badge p-2 font-size-14"
                        >Transfer Item:<u>
                            {{ selectedTransfer.itemName }}</u
                        ></span
                    >
                    <div class="text-center">
                        <small>Select API & Budget Item to Proceed</small>
                    </div>
                </div>
            </div>
            <button
                type="button"
                class="btn btn-warning position-fixed"
                style="bottom: 2%; right: 3%"
                @click="cancelTransfer"
            >
                <i class="bx bx-x me-1"></i>Cancel Transfer Items
            </button>
        </div>
        <b-modal
            id="cart-items-modal"
            title="Cart Items"
            size="lg"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <CartItems 
                :items="carts" 
                :withActions="false" 
                @select-item="selectCartItem"
            />
        </b-modal>
    </Layout>
</template>
